/* ═══════════════════════════════════════════════════════════════════════
   CONFIGURATEUR CRÉAPANEL — MOTEUR  ·  RÉVISION 20
   Fichier : assets/configurator-main.js

   Ce fichier était auparavant un bloc <script> de 175 Ko à l'intérieur de
   la section. Or une section Shopify est plafonnée à 256 Ko et la section
   en faisait déjà 262 Ko : plus rien ne pouvait y être ajouté. Le moteur
   vit donc ici, où aucune limite de ce genre ne s'applique — et il est
   désormais mis en cache par le navigateur au lieu d'être retéléchargé
   avec le HTML à chaque page produit.

   CE QUI RESTE DANS LA SECTION, et pourquoi
   · Tout ce qui contient du Liquid : configuration, prix, règles de
     collection, données produit. Liquid n'interprète pas les fichiers
     d'assets, ce code ne pourrait pas fonctionner ici.
   · Les 5 snippets de rendu, déposés dans window._CFG_RENDERERS puis
     greffés sur App plus bas, exactement comme _CFG_LEGS et _CFG_SINK.

   ORDRE DE CHARGEMENT — la balise script de la section est SYNCHRONE et
   placée exactement là où se trouvait le bloc d'origine. L'ordre
   d'exécution est donc identique à l'octet près à celui d'avant : les
   fonctions globales définies par les autres blocs (CFG_getEffectiveRules,
   CFG_applyEdgeTypes, ConfigBar) sont déjà en place. Ne pas ajouter defer
   ni async : ça décalerait ce fichier après tous les blocs en ligne.
   ═══════════════════════════════════════════════════════════════════════ */

'use strict';

    /* =========================
   DEBUG PANIER (copier-coller)
   ========================= */
window.CART_DEBUG = {
  lastItems: null,

  logItems(items) {
    this.lastItems = items;

    console.group('🧾 DEBUG — items envoyés à /cart/add.js');
    try {
      console.table(
        (items || []).map((it, i) => ({
          i,
          id: it.id,
          quantity: it.quantity,
          _addon: (it.properties && it.properties._addon) || '',
          _UID: (it.properties && it.properties._UID) || '',
          _parent_uid: (it.properties && it.properties._parent_uid) || ''
        }))
      );
    } catch (e) {
      console.log(items);
    }

    (items || []).forEach((it, i) => {
      console.log(`properties[${i}] =`, it.properties || {});
    });

    console.groupEnd();
  },

  async readCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();

    console.group('🛒 DEBUG — panier réel (/cart.js) après ajout');
    console.log('TOTAL € =', (cart.total_price / 100).toFixed(2));

    try {
      console.table(
        (cart.items || []).map((it, idx) => ({
          idx,
          variant_id: it.variant_id,
          quantity: it.quantity,
          final_line_price: it.final_line_price,
          _addon: (it.properties && it.properties._addon) || '',
          _UID: (it.properties && it.properties._UID) || '',
          _parent_uid: (it.properties && it.properties._parent_uid) || ''
        }))
      );
    } catch (e) {
      console.log(cart.items);
    }

    console.groupEnd();
    return cart;
  }
};

/* =========================
   FIN DEBUG PANIER
   ========================= */
/* ═══ CFG Rules externalisées dans snippet-cfg-rules.liquid ═══ */
    const App = {
      imageBaseUrl: '/images/variants/',
      product: null,
      shopifyVariants: [],
      options: [],
      colorOptionIndex: -1,
      variantsMeta: {},
      valueToSwatch: {},
      valueToVariantImage: {},
      S: {
      layout: 'linear',
      orderQty: 1,
      depthMode: 'standard',      // 'standard' | 'custom'
depthSelectedId: null,      // id du bouton standard OU id de gamme custom
edgeBandingByEdge: {},
        angleDir:'right',
        gDir:'right',
        junctionType:'flush',
        junctionLeftU:'flush',
        junctionRightU:'flush',
        junctionTopG:'flush',
        junctionMidG:'flush',
        junctionReturnG:'flush',
        innerAngle: 90,
        variant:'',
        L:2400,
        P:600,
        L1:2400,
        P1:600,
        L2:1200,
        P2:600,
        Lg:800,
        Lc:1000,
        Ld:800,
        Pl:600,
        Pc:600,
        Pr:600,
        Gtop: 2800,
        Pgtop: 600,
        Pgleft: 600,
        Pgright: 600,
        Pgreturn: 600,
        Gleft: 1400,
        Gright: 1600,
        Greturn: 1200,
        thk:30,
        roundRadius:30,


  legs: {                    // ✅ Sans ":" avant
    left: false,
    right: false,
    height: 720,
    thickness: 30
  },

  sink: null,               // évier : null = pas d'évier                         
  


edgeBanding: {
  front: true,
  sides: true,
  back: false,
  innerFront: true,
  angleReturn: true,
  angleReturnH: true,
  angleReturnTop: true
},


        edges:{
          topLeft:'straight',
          topRight:'straight',
          bottomLeft:'straight',
          bottomRight:'straight',
          endHTL:'straight',
          endHTR:'straight',
          endHBL:'straight',
          endHBR:'straight',
          endVTL:'straight',
          endVTR:'straight',
          endVBL:'straight',
          endVBR:'straight',
          footLTL:'straight',
          footLTR:'straight',
          footLBL:'straight',
          footLBR:'straight',
          footRTL:'straight',
          footRTR:'straight',
          footRBL:'straight',
          footRBR:'straight',
          gLeftTL:'straight',
          gLeftBL:'straight',
          gLeftBR:'straight',
          gTopTL:'straight',
          gTopTR:'straight',
          gTopBR:'straight',
          gRightTR:'straight',
          gRightBL:'straight',
          gRightBR:'straight',
          gReturnTL:'straight',
          gReturnTR:'straight',
          gReturnBL:'straight'
        },
        bevel:{
          topLeft:{dx:50,dy:50},
          topRight:{dx:50,dy:50},
          bottomLeft:{dx:50,dy:50},
          bottomRight:{dx:50,dy:50},
          endHTL:{dx:50,dy:50},
          endHTR:{dx:50,dy:50},
          endHBL:{dx:50,dy:50},
          endHBR:{dx:50,dy:50},
          endVTL:{dx:50,dy:50},
          endVTR:{dx:50,dy:50},
          endVBL:{dx:50,dy:50},
          endVBR:{dx:50,dy:50},
          footLTL:{dx:50,dy:50},
          footLBL:{dx:50,dy:50},
          footLBR:{dx:50,dy:50},
          footRTL:{dx:50,dy:50},
          footRTR:{dx:50,dy:50},
          footRBL:{dx:50,dy:50},
          footRBR:{dx:50,dy:50},
          gLeftTL:{dx:50,dy:50},
          gLeftBL:{dx:50,dy:50},
          gLeftBR:{dx:50,dy:50},
          gTopTL:{dx:50,dy:50},
          gTopTR:{dx:50,dy:50},
          gTopBR:{dx:50,dy:50},
          gRightTR:{dx:50,dy:50},
          gRightBL:{dx:50,dy:50},
          gRightBR:{dx:50,dy:50},
          gReturnTL:{dx:50,dy:50},
          gReturnTR:{dx:50,dy:50},
          gReturnBL:{dx:50,dy:50}
        },
        notch:{
          topLeft:{dx:100,dy:100,offset:0},
          topRight:{dx:100,dy:100,offset:0},
          bottomLeft:{dx:100,dy:100,offset:0},
          bottomRight:{dx:100,dy:100,offset:0},
          endHTL:{dx:100,dy:100,offset:0},
          endHTR:{dx:100,dy:100,offset:0},
          endHBL:{dx:100,dy:100,offset:0},
          endHBR:{dx:100,dy:100,offset:0},
          endVTL:{dx:100,dy:100,offset:0},
          endVTR:{dx:100,dy:100,offset:0},
          endVBL:{dx:100,dy:100,offset:0},
          endVBR:{dx:100,dy:100,offset:0},
          footLTL:{dx:100,dy:100,offset:0},
          footLTR:{dx:100,dy:100,offset:0},
          footLBL:{dx:100,dy:100,offset:0},
          footLBR:{dx:100,dy:100,offset:0},
          footRTL:{dx:100,dy:100,offset:0},
          footRTR:{dx:100,dy:100,offset:0},
          footRBL:{dx:100,dy:100,offset:0},
          footRBR:{dx:100,dy:100,offset:0},
          gLeftTL:{dx:100,dy:100,offset:0},
          gLeftBL:{dx:100,dy:100,offset:0},
          gLeftBR:{dx:100,dy:100,offset:0},
          gTopTL:{dx:100,dy:100,offset:0},
          gTopTR:{dx:100,dy:100,offset:0},
          gTopBR:{dx:100,dy:100,offset:0},
          gRightTR:{dx:100,dy:100,offset:0},
          gRightBL:{dx:100,dy:100,offset:0},
          gRightBR:{dx:100,dy:100,offset:0},
          gReturnTL:{dx:100,dy:100,offset:0},
          gReturnTR:{dx:100,dy:100,offset:0},
          gReturnBL:{dx:100,dy:100,offset:0},
          gRightTL:{dx:100,dy:100,offset:0}
        }
},
lockedBandingKeys: ['front','sides','innerFront','angleReturn'],


edgePopup: null,

      currentEdgeKey: null,
      ns:'http://www.w3.org/2000/svg',
      xlink:'http://www.w3.org/1999/xlink',
      SV(tag,attrs){
        const el=document.createElementNS(this.ns,tag);
        Object.entries(attrs||{}).forEach(([k,v])=>el.setAttribute(k,v));
        return el;
      },
   
      setImageHref(el,url){
        el.setAttribute('href',url);
        el.setAttributeNS(this.xlink,'xlink:href',url);
      },
      normalizeId(s){
        return String(s||'')
          .toLowerCase()
          .replace(/[^a-z0-9_-]+/g,'-')
          .replace(/-+/g,'-')
          .replace(/^-|-$/g,'');
      },
      normalizeColor(c){
        if(!c) return null;
        const s=String(c).trim();
        if(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(s)) return s;
        if(/^(rgb|rgba|hsl)a?\(/i.test(s)) return s;
        if(/^linear-gradient\(/i.test(s)) return s;
        return null;
      },
      guessFallbackFromText(n){
        n=String(n).toLowerCase();
        if(n.includes('blanc')||n.includes('white')) return '#f8f9fa';
        if(n.includes('noir')||n.includes('black')) return '#1a1a1a';
        if(n.includes('gris')||n.includes('béton')||n.includes('beton')||n.includes('stone')||n.includes('concrete')) return '#9ca3af';
        if(n.includes('chêne')||n.includes('oak')||n.includes('noyer')||n.includes('walnut')||n.includes('bois')||n.includes('wood')) return '#8b6f47';
        return '#e5e7eb';
      },
      // Couleur de repli d'un décor (pastille sans image) : l'aplat de la variante (window.CP_TEX[décor].hex,
      // métachamp aplat_hex), pris avant la couleur devinée d'après le nom (Bleu poudré, Cacao… n'en ont pas).
      aplatFromData(n){
        const t=window.CP_TEX, d=t && t[String(n||'').trim()];
        return (d && this.normalizeColor(d.hex)) || null;
      },
      setShopifyProduct(product){
        this.product = product || null;
        this.shopifyVariants = product?.variants || [];
        this.options = product?.options_with_values || [];
        const names=['finition','couleur','color','coloris','teinte','variante','finish'];
        this.colorOptionIndex = this.options.findIndex(o=>names.includes(String(o.name).toLowerCase()));
        if(this.colorOptionIndex<0){
          this.colorOptionIndex = this.options.findIndex(o => (o.values||[]).some(v=>v.swatch && (v.swatch.color||v.swatch.image)) );
        }
        this.buildSwatchMaps();
      },
      setShopifyVariants(v){
        this.shopifyVariants = v || [];
      },
      buildSwatchMaps(){
        this.valueToSwatch={};
        this.valueToVariantImage={};
        this.variantsMeta={};
        if(this.colorOptionIndex>=0){
          const opt=this.options[this.colorOptionIndex];
          (opt.values||[]).forEach(v=>{
            const name=String(v.value||'').trim();
            const id=this.normalizeId(name);
            const color=this.normalizeColor(v?.swatch?.color) || this.aplatFromData(name) || this.guessFallbackFromText(name);
            const swImg=v?.swatch?.image?.src || v?.swatch?.image || null;
            const match=this.shopifyVariants.find(va=>{
              const val=String(va[`option${this.colorOptionIndex+1}`]||'').toLowerCase();
              return val===name.toLowerCase();
            });
            const vimg = match?.featured_image?.src || match?.featured_image || match?.featured_media?.preview_image?.src || match?.image?.src || null;
            if(vimg) this.valueToVariantImage[id]=vimg;
            this.valueToSwatch[id]={name, color, image:swImg};
            this.variantsMeta[id]={name, fallbackColor:color};
          });
        }else{
          const seen=new Set();
          this.shopifyVariants.forEach(va=>{
            const name=(va.title||va.option1||'Variante').trim();
            const id=this.normalizeId(name);
            if(seen.has(id)) return;
            seen.add(id);
            const vimg = va.featured_image?.src || va.featured_image || va.featured_media?.preview_image?.src || va.image?.src || null;
            this.valueToVariantImage[id]=vimg;
            const col=this.aplatFromData(va.option1||name) || this.guessFallbackFromText(name);
            this.variantsMeta[id]={name, fallbackColor:col};
          });
        }
      },
      ensureVariantPatterns(variantId, fallbackColor){
        const defs=this.svg.querySelector('defs');
        const make = (rot) => {
          const pid=`pattern-${variantId}${rot?'-rot':''}`;
          if(this.svg.querySelector(`#${pid}`)) return;
          const pat=this.SV('pattern',{
            id:pid,
            width:'1',
            height:'1',
            patternUnits:'objectBoundingBox',
            patternContentUnits:'objectBoundingBox'
          });
          if(rot) pat.setAttribute('patternTransform','rotate(-90 0.5 0.5)');
          const rect=this.SV('rect',{width:'1',height:'1',fill:fallbackColor||'#e5e7eb'});
          const preserveAspect = rot ? 'xMidYMid meet' : 'xMidYMid slice';
          const img=this.SV('image',{
            id:`${variantId}Image${rot?'-rot':''}`,
            x:'0',
            y:'0',
            width:'1',
            height:'1',
            preserveAspectRatio: preserveAspect,
            style:'display:none'
          });
          pat.appendChild(rect);
          pat.appendChild(img);
          defs.appendChild(pat);
        };
        make(false);
        make(true);
      },
    getWorkImageUrl(){
  const id = (this.S.variant || '').trim();
  if(!id) return null; // ✅ évite /images/variants/.jpg
  return this.valueToVariantImage[id] || this.valueToSwatch[id]?.image || null; // ✅ pas de fallback foireux
},

      loadWorkTexture(){
        const id=this.S.variant;
        if(!id) return;
        const url=this.getWorkImageUrl();
        if(!url) return;
        const targets=[
          document.getElementById(`${id}Image`),
          document.getElementById(`${id}Image-rot`)
        ].filter(Boolean);
        const test=new Image();
        test.onload=()=>{targets.forEach(el=>{this.setImageHref(el,url);el.style.display='block';});};
        test.onerror=()=>{targets.forEach(el=>{el.style.display='none';});};
        test.src=url;
      },
      setAssemblyClip(paths){
        const defs = this.svg.querySelector('defs');
        defs.querySelectorAll('clipPath[id^="clip-assembly"]').forEach(cp => cp.remove());
        const clipUnion = this.SV('clipPath', {
          id: 'clip-assembly',
          clipPathUnits: 'userSpaceOnUse'
        });
        paths.forEach(p => {
          const path = this.SV('path', {
            d: p.d,
            transform: `translate(${p.x},${p.y})`
          });
          clipUnion.appendChild(path);
        });
        defs.appendChild(clipUnion);
        paths.forEach((p, i) => {
          const cp = this.SV('clipPath', {
            id: `clip-assembly-${i}`,
            clipPathUnits: 'userSpaceOnUse'
          });
          cp.appendChild(this.SV('path', {
            d: p.d,
            transform: `translate(${p.x},${p.y})`
          }));
          defs.appendChild(cp);
        });
      },
      addTextureBlock(
        x, y, w, h,
        {
          rot = false,
          outline = 'none',
          outlineWidth = 6,
          clipId = 'clip-assembly'
        } = {}
      ) {
        const meta = this.variantsMeta[this.S.variant] || { fallbackColor: '#e5e7eb' };
        const url = this.getWorkImageUrl();
        // Groupe pour porter le clip + l’outline + l’image
        const g = this.SV('g', {});
        const clipAttr = clipId ? `url(#${clipId})` : null;
        if (clipAttr) g.setAttribute('clip-path', clipAttr);
        if (url) {
          if (!rot) {
            // Texture horizontale
            const img = this.SV('image', {
              x, y, width: w, height: h,
              preserveAspectRatio: 'xMidYMid slice',
              style: 'pointer-events:none'
            });
            img.setAttribute('href', url);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);
            g.appendChild(img);
          } else {
            // Texture tournée pour la jambe verticale
            const img = this.SV('image', {
              x: x - (h - w) / 2,
              y: y + (h - w) / 2,
              width: h,
              height: w,
              preserveAspectRatio: 'xMidYMid slice',
              style: 'pointer-events:none'
            });
            img.setAttribute('href', url);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);
            const cx = x + w / 2;
            const cy = y + h / 2;
            img.setAttribute('transform', `rotate(90 ${cx} ${cy})`);
            g.appendChild(img);
          }
        } else {
          // Couleur de secours
          const tex = this.SV('rect', {
            x, y, width: w, height: h,
            fill: meta.fallbackColor,
            style: 'pointer-events:none'
          });
          g.appendChild(tex);
        }
        // Outline optionnel
        if (outline !== 'none') {
          const o = this.SV('rect', {
            x, y, width: w, height: h,
            fill: 'none',
            style: `pointer-events:none;stroke:${outline};stroke-width:${outlineWidth};stroke-linejoin:round`
          });
          g.appendChild(o);
        }
        this.svg.appendChild(g);
      },
      getEdgeShift(edgeKey, orientation, maxLen = 1e9) {
        // edgeKey peut être null → aucun décalage
        if (!edgeKey) return 0;
        const type = this.S.edges[edgeKey];
        if (!type || type === 'straight') return 0;
        const clamp = v => Math.max(0, Math.min(v, maxLen * 0.5));
if (type === 'bevel') {
  const b = this.S.bevel?.[edgeKey] || { dx: 0, dy: 0 };
  return orientation === 'h' ? clamp(b.dx || 0) : clamp(b.dy || 0);
}
if (type === 'notch') {
  const n = this.S.notch?.[edgeKey] || { dx: 0, dy: 0 };
  return orientation === 'h' ? clamp(n.dx || 0) : clamp(n.dy || 0);
}

        if (type === 'round1') {
          const r = this.S.roundRadius || 30;
          return clamp(r);
        }
        if (type === 'semi') {
          // demi-rond sur tout le chant → on considère que ça “mange” la moitié
          return clamp(maxLen / 2);
        }
        return 0;
      },
      addEdgeBandingIndicator(
        x1, y1, x2, y2,
        active = true,
        options = {}
      ) {
        if (!active) return null; // ← Retourner null au lieu de rien
        const {
          orientation = null,
          startEdgeKey = null,
          endEdgeKey = null,
          normalX = 0,
          normalY = 0,
          normalOffset = 6
        } = options;
        if (orientation && (startEdgeKey || endEdgeKey)) {
          const isH = orientation === 'h';
          const len = isH ? Math.abs(x2 - x1) : Math.abs(y2 - y1);
          if (len > 0) {
            const dir = isH ? (x2 >= x1 ? 1 : -1) : (y2 >= y1 ? 1 : -1);
            const shiftStart = this.getEdgeShift(startEdgeKey, orientation, len);
            const shiftEnd = this.getEdgeShift(endEdgeKey, orientation, len);
            if (isH) {
              x1 += dir * shiftStart;
              x2 -= dir * shiftEnd;
            } else {
              y1 += dir * shiftStart;
              y2 -= dir * shiftEnd;
            }
          }
        }
        if (normalX || normalY) {
          x1 += normalX * normalOffset;
          y1 += normalY * normalOffset;
          x2 += normalX * normalOffset;
          y2 += normalY * normalOffset;
        }
        const line = this.SV('line', {
          x1, y1, x2, y2,
          stroke: '#1F51FF',
          'stroke-width': '16',
          'stroke-linecap': 'round',
          opacity: '0.8',
          'pointer-events': 'none' // ✅ AJOUT ICI
        });
        this.svg.appendChild(line);
        return line; // ✅ RETOURNER LA LIGNE
      },
    addEdgeCheckbox(
  x,
  y,
  edge,
  checked = false,
  disabled = false,
  forceReason = 'none',
  sourceEdgeKey = null
) {
  // ✅ état
  this.S.edgeBanding = this.S.edgeBanding || {};
  this.S.edgeBandingByEdge = this.S.edgeBandingByEdge || {};

  const bKey = String(edge || '');
  const eKey = (sourceEdgeKey != null) ? String(sourceEdgeKey) : null;

  // ✅ container
  const container = document.createElement('div');
  container.className = 'edge-checkbox-container';
  container.style.position = 'absolute';
  container.style.transform = 'translate(-50%, -50%)';
  container.style.zIndex = '100';

  // ⚠️ on garde pointer-events au niveau container pour simplifier
  container.style.pointerEvents = disabled ? 'none' : 'all';
  container.style.opacity = disabled ? '0.45' : '1';

  // ✅ checkbox visuelle
  const checkbox = document.createElement('div');
  checkbox.className = 'edge-checkbox-visual';
  checkbox.classList.toggle('checked', !!checked);
  checkbox.classList.toggle('disabled', !!disabled);

  // ✅ dataset
  checkbox.dataset.edge = bKey;
  checkbox.dataset.disabled = disabled ? '1' : '0';
  checkbox.dataset.forceReason = String(forceReason || 'none');
  if (eKey) checkbox.dataset.sourceEdgeKey = eKey;
  const isDisabledByBackoffice = (forceReason === 'locked' || forceReason === 'forceAll' || forceReason === 'depthThreshold');
checkbox.dataset.initiallyDisabled = isDisabledByBackoffice ? '1' : '0';

  // ✅ enregistrer le lien "auto-activé par ce bord"
  // (utile pour clearEdgeType / auto-décochage)
  if (forceReason === 'edge' && eKey) {
    if (!this.S.edgeBandingByEdge[eKey]) this.S.edgeBandingByEdge[eKey] = {};
    this.S.edgeBandingByEdge[eKey][bKey] = true;
  }

  // ✅ toggle
  if (!disabled) {
    checkbox.addEventListener('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      const currentlyChecked = checkbox.classList.contains('checked');
      const next = !currentlyChecked;

      // DOM
      checkbox.classList.toggle('checked', next);

      // state
      this.S.edgeBanding[bKey] = next;

      // l'utilisateur reprend la main -> plus "forcé"
      checkbox.dataset.forceReason = 'none';

      // retirer l'association edge->banding si elle existait
      const src = checkbox.dataset.sourceEdgeKey;
      if (src && this.S.edgeBandingByEdge?.[src]) {
        delete this.S.edgeBandingByEdge[src][bKey];
        if (Object.keys(this.S.edgeBandingByEdge[src]).length === 0) {
          delete this.S.edgeBandingByEdge[src];
        }
      }

      this.updateEdgesRecap();
      this.render();
    });
  }

  container.appendChild(checkbox);
  this.dims.appendChild(container);

  // ✅ positionnement
  const pos = this.svgToClient(x, y);
  const hostRect = this.dims.getBoundingClientRect();
  container.style.left = `${pos.px - hostRect.left}px`;
  container.style.top  = `${pos.py - hostRect.top}px`;

  return container;
}
,

      setupEdgeBanding(){
        const edgeBack = document.getElementById('edge-back');
        if (!edgeBack) return;
        edgeBack.checked = this.S.edgeBanding.back;
        edgeBack.addEventListener('change', (e) => {
          this.S.edgeBanding.back = e.target.checked;
          this.updateEdgesRecap();
          this.render();
        });
      },
      updateEdgesRecap(){
        const recEdges = document.getElementById('rec-edges');
        if (!recEdges) return;
        const edges = [];
        const hasFront = this.S.edgeBanding.front || this.S.edgeBanding.innerFront;
        if (hasFront) edges.push('Avant'); // 👈 compte aussi le 1000 intérieur
        if (this.S.edgeBanding.sides) edges.push('Latéraux');
        if (this.S.edgeBanding.back) edges.push('Arrière');
        // si tu veux afficher les retours d’angle :
        // if (this.S.edgeBanding.angleReturn) edges.push('Retours d’angle');
        recEdges.textContent = edges.join(' + ');
      },


resolveBanding(key, autoEnable = false) {
  const eff = this._eff || {};
  const locked = eff.bandingLocked || {};
  const forceAll = eff.forceAllBanding === true;
  const forceFromDepth = Number(eff.forceBandingFromDepth || 0);

  // ✅ Vérifier si la profondeur actuelle déclenche le forçage
  const currentDepth = this.getCurrentDepthMm();
  const depthTriggered = (forceFromDepth > 0 && currentDepth >= forceFromDepth);

  // ✅ force global OU profondeur >= seuil
  if (forceAll || depthTriggered) {
    this.S.edgeBanding[key] = true;
    return { 
      checked: true, 
      disabled: true, 
      reason: depthTriggered ? 'depthThreshold' : 'forceAll' 
    };
  }

  // ✅ lock collection (uniquement ça)
  if (locked[key] === true) {
    this.S.edgeBanding[key] = true;
    return { checked: true, disabled: true, reason: 'locked' };
  }

  // ✅ forcé par un coin (edge type)
  if (autoEnable) {
    this.S.edgeBanding[key] = true;
    return { checked: true, disabled: true, reason: 'edge' };
  }

  // ✅ sinon : uniquement l'état réel choisi par l'utilisateur
  return {
    checked: this.S.edgeBanding[key] === true,
    disabled: false,
    reason: 'none'
  };
}

,
updateTdOptionsList() {
  console.log('🔴 updateTdOptionsList APPELÉE'); // ← Ajoutez cette ligne
  const td = document.getElementById('td-options');
  if (!td) return;

  const euroToCents = (e) => Math.round(Number(e || 0) * 100);
  const fmtEuro = (cents) =>
    (Number(cents || 0) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const forceFromDepth = Number(this._eff?.forceBandingFromDepth || 0);

  // Helper pour vérifier si un chant spécifique est forcé par depthThreshold
  const isChantForcedByDepth = (bandingKey) => {
    if (forceFromDepth <= 0) return false;
    
    const shape = this.S.layout || 'linear';
    
    if (shape === 'linear') {
      return Number(this.S.P || 0) >= forceFromDepth;
    }
    
    if (shape === 'angle') {
      const BANDING_KEYS_H = ['front', 'back', 'sidesBarreH', 'angleReturnH', 'angleReturnTop'];
      const BANDING_KEYS_V = ['sidesJambeVInner', 'sidesJambeVBottom', 'angleReturn'];
      
      if (BANDING_KEYS_H.includes(bandingKey)) return Number(this.S.P1 || 0) >= forceFromDepth;
      if (BANDING_KEYS_V.includes(bandingKey)) return Number(this.S.P2 || 0) >= forceFromDepth;
      return false;
    }
    
    if (shape === 'u-shape') {
      const BANDING_KEYS_PC = ['backLeftU', 'backMidU', 'backRightU', 'backflol_left', 'backflol_right', 'backolfl_left', 'backolfl_right', 'innerFront'];
      const BANDING_KEYS_PL = ['front', 'sideLeftU', 'sideLeftUTop', 'sideLeftUBot'];
      const BANDING_KEYS_PR = ['sides', 'sideRightU', 'sideRightUTop', 'sideRightUBot'];
      const BANDING_KEYS_SHARED = ['angleReturn'];
      
      if (BANDING_KEYS_PC.includes(bandingKey)) return Number(this.S.Pc || 0) >= forceFromDepth;
      if (BANDING_KEYS_PL.includes(bandingKey)) return Number(this.S.Pl || 0) >= forceFromDepth;
      if (BANDING_KEYS_PR.includes(bandingKey)) return Number(this.S.Pr || 0) >= forceFromDepth;
      if (BANDING_KEYS_SHARED.includes(bandingKey)) return (Number(this.S.Pl || 0) >= forceFromDepth) || (Number(this.S.Pr || 0) >= forceFromDepth);
      return false;
    }
    
    if (shape === 'g-shape') {
      if (bandingKey.toLowerCase().includes('top')) return Number(this.S.Pgtop || 0) >= forceFromDepth;
      if (bandingKey.toLowerCase().includes('left') && !bandingKey.toLowerCase().includes('right')) return Number(this.S.Pgleft || 0) >= forceFromDepth;
      if (bandingKey.toLowerCase().includes('right')) return Number(this.S.Pgright || 0) >= forceFromDepth;
      if (bandingKey.toLowerCase().includes('return')) return Number(this.S.Pgreturn || 0) >= forceFromDepth;
      return false;
    }
    
    return false;
  };

  const areAllDepthsTriggered = () => {
    if (forceFromDepth <= 0) return false;
    
    const shape = this.S.layout || 'linear';
    
    if (shape === 'linear') return Number(this.S.P || 0) >= forceFromDepth;
    if (shape === 'angle') return (Number(this.S.P1 || 0) >= forceFromDepth) && (Number(this.S.P2 || 0) >= forceFromDepth);
    if (shape === 'u-shape') return (Number(this.S.Pc || 0) >= forceFromDepth) && (Number(this.S.Pl || 0) >= forceFromDepth) && (Number(this.S.Pr || 0) >= forceFromDepth);
    if (shape === 'g-shape') return (Number(this.S.Pgtop || 0) >= forceFromDepth) && (Number(this.S.Pgleft || 0) >= forceFromDepth) && (Number(this.S.Pgright || 0) >= forceFromDepth) && (Number(this.S.Pgreturn || 0) >= forceFromDepth);
    return false;
  };

  const allDepthsTriggered = areAllDepthsTriggered();
  const hideEdgeSupplements = (this._eff?.forceAllBanding === true) || allDepthsTriggered;

  // ========================================
  // ✅ COMPTAGE CORRIGÉ : 1 supplément par clé de chant unique
  // ========================================
  const unitChantCents = euroToCents(
    (this._eff?.edgeBandingUnitEuro != null ? this._eff.edgeBandingUnitEuro : 0)
  );

  const BASE_CHANTS = new Set(this.lockedBandingKeys || []);

  // Récupérer toutes les checkboxes cochées
  const allCheckedEls = this.dims
    ? Array.from(this.dims.querySelectorAll('.edge-checkbox-visual.checked'))
    : [];

  // Dans updateTdOptionsList(), remplacez la section de comptage par :

// ✅ COMPTAGE SIMPLIFIÉ : locked dans backoffice = jamais de supplément
const chantSupplements = new Map();
const bandingLocked = this._eff?.bandingLocked || {};

// Déterminer le préfixe selon la forme
const getConfigKey = (key) => {
  const layout = this.S.layout || 'linear';
  if (layout === 'linear') return `linear_${key}`;
  if (layout === 'angle') return `angle_${key}`;
  if (layout === 'u-shape') return `u_${key}`;
    if (layout === 'g-shape') {
    const isGL = /GL(?:_|$)/.test(key);
    return isGL ? `gl_${key}` : `g_${key}`;
  }
  return key;
};

console.log('=== DEBUG CHANTS SUPPLEMENTS ===');
console.log('Checkboxes cochées trouvées:', allCheckedEls.length);

allCheckedEls.forEach((el, idx) => {
  const key = el.dataset.edge || '';
  
  console.log(`[${idx}] key="${key}" disabled=${el.classList.contains('disabled')} reason=${el.dataset.forceReason}`);
  
  if (!key) return;
  
  // Déjà traité ?
  if (chantSupplements.has(key)) {
    console.log(`  → SKIP (déjà traité)`);
    return;
  }
  
  // ✅ RÈGLE SIMPLE : si locked dans backoffice → JAMAIS de supplément
  const configKey = getConfigKey(key);
  const isLockedByBackoffice = bandingLocked[configKey] === true;
  
  if (isLockedByBackoffice) {
    console.log(`  → SKIP (locked backoffice: ${configKey})`);
    chantSupplements.set(key, false);
    return;
  }
  
  // Forcé par forceAll ou depthThreshold → pas de supplément non plus
  const reason = el.dataset.forceReason || 'none';
  if (reason === 'forceAll' || reason === 'depthThreshold' || isChantForcedByDepth(key)) {
    console.log(`  → SKIP (reason=${reason})`);
    chantSupplements.set(key, false);
    return;
  }
  
  // ✅ Tout le reste = supplément si coché
  const isChecked = el.classList.contains('checked');
  if (isChecked) {
    console.log(`  → ✅ SUPPLÉMENT COMPTÉ`);
    chantSupplements.set(key, true);
  } else {
    console.log(`  → NON (pas cochée)`);
    chantSupplements.set(key, false);
  }
});

let chantsCount = 0;
chantSupplements.forEach((isSuppl, key) => {
  if (isSuppl) {
    chantsCount++;
    console.log(`SUPPLÉMENT FINAL: ${key}`);
  }
});
console.log(`TOTAL: ${chantsCount} chants supplémentaires`);
console.log('================================');
/* R148-b2 (COMMERCIAL ; AUDIT 20:41) : les clés des chants comptés, dans l'ordre, pour la ligne de chaque chant (cp-modele,
   chantsParLigne) ; les modules qui retirent un chant de « Chants supp. » notent sa clé dans _cpChantsRetires */
this._cpChantsComptes = hideEdgeSupplements ? [] : Array.from(chantSupplements).filter((e) => e[1]).map((e) => e[0]);
this._cpChantsRetires = [];

  // 2) Types de bords
  const LAYOUT_EDGE_KEYS = {
    linear:   ['topLeft','topRight','bottomLeft','bottomRight'],
    angle:    ['endHTL','endHTR','endHBL','endHBR','endVTL','endVTR','endVBL','endVBR'],
    'u-shape':['footLTL','footLBL','footLBR','footRTR','footRBL','footRBR'],
    'g-shape':['gLeftTL','gLeftBL','gLeftBR','gTopTL','gTopTR','gTopBR','gRightTR','gRightBL','gRightBR','gReturnTL','gReturnTR','gReturnBL']
  };

  const keys = (LAYOUT_EDGE_KEYS[this.S.layout] || []).filter(k => this.S.edges && (k in this.S.edges));

  const counts = { round1: 0, semi: 0, bevel: 0, notch: 0 };
  keys.forEach(k => {
    const t = this.S.edges[k];
    if (t === 'round1') counts.round1++;
    else if (t === 'semi') counts.semi++;
    else if (t === 'bevel') counts.bevel++;
    else if (t === 'notch') counts.notch++;
  });

  const rows = [];
  const pushLine = (label, qty, unitCents) => {
    if (!qty || qty <= 0) return;
    const u = Number(unitCents || 0);
    if (u <= 0) return;
    rows.push({ label, qty, unitCents: u, totalCents: qty * u });
  };

  // ✅ Ajouter "Chants supp." uniquement si la règle ne force pas tous les chants
  if (!hideEdgeSupplements) {
    pushLine('Chants supp.', chantsCount, unitChantCents);
  }

  const edgeEuro = this._eff?.edgePricesEuro || {};

  pushLine('Coins arrondis', counts.round1, euroToCents(edgeEuro.round1));
  pushLine('Demi-ronds',     counts.semi,   euroToCents(edgeEuro.semi));
  pushLine('Chanfreins',     counts.bevel,  euroToCents(edgeEuro.bevel));
  pushLine('Encoches',       counts.notch,  euroToCents(edgeEuro.notch));

  // Épaisseur (facturée par mètre linéaire, comme la profondeur)
  const thkOpts = window.CONFIGURATOR_CONFIG?.thicknessOptions || [];
  const thk = Number(this.S.thk || 0);
  const thkObj = thkOpts.find(o => Number(o.mm) === thk);
  const thkEuroPerMeter = Number(thkObj?.extraPrice || 0);
  if (thk && thkEuroPerMeter > 0) {
    const totalLenMm = this.getTotalLengthMm();
    const thkCents = Math.round(thkEuroPerMeter * (totalLenMm / 1000) * 100);
    if (thkCents > 0) pushLine(`Épaisseur ${thk} mm (+${thkEuroPerMeter}€/m)`, 1, thkCents);
  }

  // Profondeurs
  const depthSupplements = this.calculateDepthSupplements();
  if (depthSupplements.total > 0) {
    depthSupplements.items.forEach(item => {
      pushLine(item.label, 1, item.cents);
    });
  }

  // Jambages
  const legsSupplements = this.calculateLegsSupplements();
  if (legsSupplements.total > 0) {
    legsSupplements.items.forEach(item => {
      pushLine(item.label, 1, item.cents);
    });
  }

  // Évier
  const sinkSupplements = this.calculateSinkSupplements();
  if (sinkSupplements.total > 0) {
    sinkSupplements.items.forEach(item => {
      pushLine(item.label, 1, item.cents);
    });
  }

  // Hors d'équerre
  const unitInnerAngleCents = euroToCents(edgeEuro.innerAngle || 0);
  const ang = Number(this.S.innerAngle || 90);

  let qtyInnerAngle = 0;
  if (ang !== 90) {
    if (this.S.layout === 'angle') qtyInnerAngle = 1;
    else if (this.S.layout === 'u-shape') qtyInnerAngle = 2;
    else if (this.S.layout === 'g-shape') qtyInnerAngle = 2;
  }
  if (qtyInnerAngle > 0) pushLine(`Hors d'équerre (${ang}°)`, qtyInnerAngle, unitInnerAngleCents);

  // Render
  if (!rows.length) {
    td.textContent = '—';
  } else {
    const wasOpen = td.querySelector('.td-options-dropdown')?.open ?? true;
    const totalExtras = rows.reduce((s, r) => s + (r.totalCents || 0), 0);

    td.innerHTML = `
      <details class="td-options-dropdown" ${wasOpen ? 'open' : ''}>
        <summary>Suppléments : +${fmtEuro(totalExtras)}€</summary>

        <div class="td-options-scroll">
          <ul class="td-options-list">
            ${rows.map(r => `
              <li>
                ${r.label} : ${r.qty > 1 ? `${r.qty} × ${fmtEuro(r.unitCents)} € = +${fmtEuro(r.totalCents)} €` : `+${fmtEuro(r.totalCents)} €`}
              </li>
            `).join('')}
          </ul>
        </div>
      </details>
    `;
  }

  this.S.optionsTotalCents = rows.reduce((sum, r) => sum + r.totalCents, 0);
},


renderThicknessUI() {
  const host = document.getElementById('thk-container');
  if (!host) return;

  // options venant du backoffice
  let opts = (window.CONFIGURATOR_CONFIG?.thicknessOptions || []).slice();

  // fallback si aucun block n’est créé dans Shopify
  if (!opts.length) {
    opts = [
      { mm: 30, label: '30 mm', extraPrice: 0 },
      { mm: 40, label: '40 mm', extraPrice: 0 }
    ];
  }

  // ✅ Filtre par collection (si activé)
  const tr = this._eff?.thicknessRule;
  if (tr?.enabled && Array.isArray(tr.allowed) && tr.allowed.length) {
    const allowedSet = new Set(tr.allowed.map(Number));
    const filtered = opts.filter(o => allowedSet.has(Number(o.mm)));

    // si filtre vide => on garde tout (évite écran cassé)
    if (filtered.length) opts = filtered;
    else console.warn('⚠️ thicknessRule enabled mais liste invalide -> fallback toutes épaisseurs', tr.allowed);
  }

  // tri par mm
  opts.sort((a, b) => Number(a.mm) - Number(b.mm));

  // si épaisseur actuelle invalide -> on met la première
  const current = Number(this.S.thk || 0);
  const hasCurrent = opts.some(o => Number(o.mm) === current);
  if (!hasCurrent) this.S.thk = Number(opts[0].mm);

  host.innerHTML = '';

  opts.forEach((o, idx) => {
    const mm = Number(o.mm);
    const id = `thk-${mm}`;

    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'thk';
    input.id = id;
    input.value = String(mm);
    input.checked = (Number(this.S.thk) === mm);

    const label = document.createElement('label');
    label.htmlFor = id;
    label.textContent = o.label && o.label.trim() ? o.label : `${mm} mm`;

    // ✅ ICI EXACTEMENT (juste après avoir créé input + label, avant addEventListener)
    const locked = (this._eff?.thicknessRule?.lock === true) || (opts.length === 1);
    input.disabled = locked;
    if (locked) label.classList.add('is-disabled');
    else label.classList.remove('is-disabled');

    
    input.addEventListener('change', () => {
      this.S.thk = mm;
      this.render();
    });

    host.appendChild(input);
    host.appendChild(label);
  });
},



applyLayoutUI() {
  // 🔥 SECTIONS COMPLÈTES (avec le parent)
  const angleOrientSection = document.getElementById('angle-orientation-section');
  const gOrientSection     = document.getElementById('g-orientation-section');
  const junctionTitle      = document.getElementById('junction-title');
  const junctionType       = document.getElementById('junction-type');
  const junctionUHint      = document.getElementById('junction-u-hint');
  const junctionAngleHint  = document.getElementById('junction-angle-hint');

  // Tout masquer (par défaut)
  if (angleOrientSection) angleOrientSection.style.display = 'none';
  if (gOrientSection)     gOrientSection.style.display     = 'none';
  if (junctionTitle)      junctionTitle.style.display      = 'none';
  if (junctionType)       junctionType.style.display       = 'none';
  if (junctionUHint)      junctionUHint.style.display      = 'none';
  if (junctionAngleHint)  junctionAngleHint.style.display  = 'none';

  // Afficher selon la forme
  if (this.S.layout === 'angle') {
    if (angleOrientSection) angleOrientSection.style.display = 'block';
    if (junctionTitle)      junctionTitle.style.display      = 'block';
    if (junctionType)       junctionType.style.display       = 'flex';
    if (junctionAngleHint)  junctionAngleHint.style.display  = 'block';
  }
  else if (this.S.layout === 'u-shape') {
    if (junctionTitle) junctionTitle.style.display = 'block';
    if (junctionUHint) junctionUHint.style.display = 'block';
  }
  else if (this.S.layout === 'g-shape') {
    if (gOrientSection) gOrientSection.style.display = 'block';
    if (junctionTitle)  junctionTitle.style.display  = 'block';
    if (junctionUHint)  junctionUHint.style.display  = 'block';
  }
},


updateTdEpaisseur() {
  const td = document.getElementById('td-epaisseur');
  if (!td) return;

  const mm = Number(this.S.thk || 0);
  td.textContent = mm ? `${mm} mm` : '—';
},

formatEuro(n) {
  const x = Number(n || 0);
  return x.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
},

// convertit un "price" Shopify (souvent en cents) en euros
priceToEuro(price) {
  if (price == null) return 0;

  // le plus courant dans product | json : cents (ex 12900)
  if (typeof price === 'number') return price / 100;

  const s = String(price).trim().replace(',', '.');

  // si c'est un entier en string => cents
  if (/^\d+$/.test(s)) return parseInt(s, 10) / 100;

  // si c'est un nombre "12.90" => euros
  const v = Number(s);
  return isNaN(v) ? 0 : v;
},

getSelectedShopifyVariant() {
  // 0) PRIORITÉ : ta finition choisie dans le configurateur (this.S.variant)
  const desiredName = this.variantsMeta?.[this.S.variant]?.name;

  if (desiredName && (this.shopifyVariants || []).length) {
    // Si on a trouvé l'option "finition/couleur" dans Shopify
    if (this.colorOptionIndex >= 0) {
      const key = `option${this.colorOptionIndex + 1}`;
      const match = (this.shopifyVariants || []).find(v =>
        String(v?.[key] || '').toLowerCase() === String(desiredName).toLowerCase()
      );
      if (match) return match;
    }

    // fallback : match par title (si pas d'option couleur)
    const match2 = (this.shopifyVariants || []).find(v =>
      String(v?.title || '').toLowerCase().includes(String(desiredName).toLowerCase())
    );
    if (match2) return match2;
  }

  // 1) fallback URL ?variant=
  const urlId = new URLSearchParams(window.location.search).get('variant');
  if (urlId) {
    const v = (this.shopifyVariants || []).find(va => String(va.id) === String(urlId));
    if (v) return v;
  }

  // 2) fallback input Shopify
  const input = document.querySelector('input[name="id"]:checked, input[name="id"]');
  if (input?.value) {
    const v = (this.shopifyVariants || []).find(va => String(va.id) === String(input.value));
    if (v) return v;
  }

  // 3) fallback final
  return (this.shopifyVariants || [])[0] || null;
}
,

getUnitPriceCents() {
  const v = this.getSelectedShopifyVariant();
  if (v && v.price != null) return Number(v.price) || 0;        // Shopify = centimes
  if (this.product && this.product.price != null) return Number(this.product.price) || 0;
  return 0;
},

getUnitPriceEuro() {
  return this.getUnitPriceCents() / 100;
},


getCurrentDepthMm() {
  // Retourne la profondeur actuelle selon le layout
  const n = (v) => Number(v || 0);
  
  if (this.S.layout === 'linear') {
    return n(this.S.P);
  }
  if (this.S.layout === 'angle') {
    // Prendre la plus grande profondeur
    return Math.max(n(this.S.P1), n(this.S.P2));
  }
  if (this.S.layout === 'u-shape') {
    return Math.max(n(this.S.Pl), n(this.S.Pc), n(this.S.Pr));
  }
  if (this.S.layout === 'g-shape') {
    return Math.max(n(this.S.Pgtop), n(this.S.Pgleft), n(this.S.Pgright), n(this.S.Pgreturn));
  }
  return n(this.S.P) || 600;
},


getTotalLengthMm() {
  const n = (v) => Number(v || 0);

  if (this.S.layout === 'linear') return n(this.S.L);

  if (this.S.layout === 'angle') {
    return n(this.S.L1) + n(this.S.L2);
  }

  if (this.S.layout === 'u-shape') {
    const Lc = n(this.S.Lc);
    const Lg = n(this.S.Lg);
    const Ld = n(this.S.Ld);
    const Pc = n(this.S.Pc);
    const Pl = n(this.S.Pl);
    const Pr = n(this.S.Pr);

    const leftIsFlush  = (this.S.junctionLeftU  === 'flush');
    const rightIsFlush = (this.S.junctionRightU === 'flush');

    let total = 0;

    // mêmes 4 cas que dans renderU()
    if (leftIsFlush && rightIsFlush) {
      total = Lg + Pc + Ld + Pc + Lc;
    } else if (leftIsFlush && !rightIsFlush) {
      total = Lg + Pc + Lc + Pl + Ld;
    } else if (!leftIsFlush && rightIsFlush) {
      total = Lg + Lc + Pr + Ld + Pc;
    } else {
      total = Lg + Lc + Pr + Pl + Ld;
    }

    return Math.max(0, Math.round(total));
  }

  if (this.S.layout === 'g-shape') {
    const Gtop    = n(this.S.Gtop);
    const Gleft   = n(this.S.Gleft);
    const Gright  = n(this.S.Gright);
    const Greturn = n(this.S.Greturn);

    const Pgtop    = n(this.S.Pgtop);
    const Pgleft   = n(this.S.Pgleft);
    const Pgright  = n(this.S.Pgright);
    const Pgreturn = n(this.S.Pgreturn);

    const topIsFlush    = (this.S.junctionTopG    === 'flush');
    const midIsFlush    = (this.S.junctionMidG    === 'flush');
    const returnIsFlush = (this.S.junctionReturnG === 'flush');

    const isRight = (this.S.gDir === 'right');

    let total = 0;

    if (isRight) {
      // ==========================
      // G DROIT : 8 combinaisons
      // TurnTop    : flush => Pgtop,    overlap => Pgleft
      // TurnMid    : flush => Pgtop,    overlap => Pgright
      // TurnReturn : flush => Pgreturn, overlap => Pgright
      // ==========================

      if (topIsFlush && midIsFlush && returnIsFlush) {
        total = Gleft + Pgtop + Gtop + Gright + Greturn;
      } else if (topIsFlush && midIsFlush && !returnIsFlush) {
        total = Gleft + Pgtop + Gtop + Gright - Pgreturn + Greturn + Pgright; // fait
      } else if (topIsFlush && !midIsFlush && returnIsFlush) {
        total = Gleft + Pgtop + Gtop + Pgright + Gright + Pgreturn + Greturn - Pgright; // fait
      } else if (topIsFlush && !midIsFlush && !returnIsFlush) {
        total = Gleft + Pgtop + Gtop - Pgright + Gright + Pgtop + Pgreturn + Greturn - Pgright; // fait
      } else if (!topIsFlush && midIsFlush && returnIsFlush) {
        total = Gleft + Pgleft + Gtop + Pgtop + Gright + Pgreturn + Greturn - Pgright;
      } else if (!topIsFlush && midIsFlush && !returnIsFlush) {
        total = Gleft + Pgleft + Gtop + Pgtop + Gright + Pgright + Greturn - Pgright;
      } else if (!topIsFlush && !midIsFlush && returnIsFlush) {
        total = Gleft + Pgleft + Gtop + Pgright + Gright + Pgreturn + Greturn - Pgright;
      } else {
        total = Gleft + Pgleft + Gtop + Pgright + Gright + Pgright + Greturn - Pgright;
      }

    } else {
      // ==========================
      // G GAUCHE (miroir) : 8 combinaisons
      // TurnTop    : flush => Pgtop,    overlap => Pgright
      // TurnMid    : flush => Pgtop,    overlap => Pgleft
      // TurnReturn : flush => Pgreturn, overlap => Pgleft
      // ==========================

      if (topIsFlush && midIsFlush && returnIsFlush) {
        total = Gright + Pgtop + Gtop + Pgtop + Gleft + Pgreturn + Greturn;
      } else if (topIsFlush && midIsFlush && !returnIsFlush) {
        total = Gright + Pgtop + Gtop + Pgtop + Gleft + Pgleft + Greturn;
      } else if (topIsFlush && !midIsFlush && returnIsFlush) {
        total = Gright + Pgtop + Gtop + Pgleft + Gleft + Pgreturn + Greturn;
      } else if (topIsFlush && !midIsFlush && !returnIsFlush) {
        total = Gright + Pgtop + Gtop + Pgleft + Gleft + Pgleft + Greturn;
      } else if (!topIsFlush && midIsFlush && returnIsFlush) {
        total = Gright + Pgright + Gtop + Pgtop + Gleft + Pgreturn + Greturn;
      } else if (!topIsFlush && midIsFlush && !returnIsFlush) {
        total = Gright + Pgright + Gtop + Pgtop + Gleft + Pgleft + Greturn;
      } else if (!topIsFlush && !midIsFlush && returnIsFlush) {
        total = Gright + Pgright + Gtop + Pgleft + Gleft + Pgreturn + Greturn;
      } else {
        total = Gright + Pgright + Gtop + Pgleft + Gleft + Pgleft + Greturn;
      }
    }

    return Math.max(0, Math.round(total));
  }

  return 0;
}
,

// ✅ Quantité FACTURÉE (cm) = seule source de vérité
getBilledQtyCm(variantOverride = null) {
  // mm -> cm (garde ton arrondi actuel)
  let qty = Math.max(0, Math.round(this.getTotalLengthMm() / 10));

  // applique les règles Shopify (min / increment / max) SUR LA QUANTITÉ
  const v = variantOverride || this.getSelectedShopifyVariant();
  const rule = v?.quantity_rule || {};
  const min = Number(rule.min || 1);
  const inc = Number(rule.increment || 1);
  const max = (rule.max == null) ? null : Number(rule.max);

  qty = Math.max(min, qty);
  if (inc > 1) qty = Math.ceil(qty / inc) * inc;
  if (max != null) qty = Math.min(max, qty);

  return Math.max(1, qty);
},

// compat : garde tes anciens noms mais pointe vers la vérité
getQuantiteCmLineaire() {
  return this.getBilledQtyCm();
},

getQtyUnitsCm() {
  return this.getBilledQtyCm();
},


updateTdLongueurTotal() {
  const td = document.getElementById('quantite_dimensions');
  if (!td) return;

  // ✅ si vendu par surface : uniquement en linéaire
  const sellBySurface = (this._eff?.sellBySurface === true);
  const isLinear = (this.S.layout === 'linear');

  if (sellBySurface && isLinear) {
    const Lmm = Number(this.S.L || 0);
    const Pmm = Number(this.S.P || 0);

    const surfaceM2 = Math.max(0, (Lmm * Pmm) / 1_000_000);

    // ✅ affichage surface
    td.textContent = surfaceM2 ? `${surfaceM2.toFixed(3)} m²` : '—';

    // ✅ pour debug / éventuel panier
    td.dataset.surfaceM2 = String(surfaceM2);

    // on ne touche pas qtyCm ici (la quantité Shopify reste au système cm)
    return;
  }

  // ✅ sinon : comportement normal (cm facturés)
  const v = this.getSelectedShopifyVariant();
  const qtyCm = this.getBilledQtyCm(v);

  this.S.qtyCm = qtyCm;
  td.dataset.qtyCm = String(qtyCm);

 const meta = window.__PRODUCT_META__ || {};
const coeff = Number(meta.coeff) || 1;
const unite = String(meta.unite_de_vente || 'cm').trim();
const displayed = (qtyCm / coeff).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
td.textContent = qtyCm ? `${displayed} ${unite}` : '—';
},


updateRecapLengthHeader() {
  /* V2 : le label est un <span> avec id="recap-length-label" */
  const label = document.getElementById('recap-length-label');
  const th = document.querySelector('th.recap-col-longueur');

  const sellBySurface = (this._eff?.sellBySurface === true);
  const isLinear = (this.S.layout === 'linear');
  const text = (sellBySurface && isLinear) ? 'Surface totale' : 'Longueur totale';

  if (label) label.textContent = text;
  if (th) th.textContent = text;
},



getQuantiteFromTable() {
  const el = document.getElementById('quantite_dimensions');
  if (!el) return 0;

  const d = el.dataset.qtyCm;
  if (d && !isNaN(Number(d))) return Number(d);

  const m = String(el.textContent || '').replace(',', '.').match(/(\d+(\.\d+)?)/);
  return m ? Number(m[1]) : 0;
},


updateTdPrixTotal() {
  const td = document.getElementById('td-prix-total');
  if (!td) return;

  const unitCents = this.getCalculatedUnitTotalCents(); // ✅ unitaire

  // stock unitaire (utile panier/debug)
  this.S.unitTotalCents = unitCents;

  td.textContent = (unitCents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + '€';
}
,

/* ✅ V2 : Total hors config (prix base sans suppléments) */
updateTdPrixBase() {
  const td = document.getElementById('td-prix-base');
  if (!td) return;
  const v = this.getSelectedShopifyVariant();
  const qtyCm = this.getBilledQtyCm(v);
  const unitCents = this.getUnitPriceCents();
  const baseCents = Math.max(0, Math.round(qtyCm * unitCents));
  td.textContent = (baseCents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + '€';
},

updateDisplayedMultiTotal() {
  const el = document.getElementById('total-multi-price');
  if (!el) return;

  const totalCents = this.getCalculatedTotalCents(); // ✅ x quantité
  el.textContent = (totalCents / 100).toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + '€';
}
,

getOptionsTextForCart() {
  if (typeof window.CP_chantsParLigne === 'function') { try { window.CP_chantsParLigne(this); } catch (e) {} }   /* R148-b2 : une ligne par chant, avant la lecture */
  const td = document.getElementById('td-options');
  if (!td) return '';
  const lis = Array.from(td.querySelectorAll('li')).map(li => li.textContent.trim()).filter(Boolean);
  if (lis.length) return lis.join(' | ');
  return (td.textContent || '').trim();
},

getCalculatedTotalCents() {
  const v = this.getSelectedShopifyVariant();
  const qtyCm = this.getBilledQtyCm(v);             // quantité facturée (cm)
  const unitCents = this.getUnitPriceCents();       // centimes / cm
  const supplCents = Number(this.S.optionsTotalCents || 0);

  const baseCents = qtyCm * unitCents;
  const oneCents = baseCents + supplCents;

  const q = Math.max(1, parseInt(this.S.orderQty, 10) || 1);

  return Math.max(0, Math.round(oneCents * q));
},


getCalculatedUnitTotalCents() {
  const v = this.getSelectedShopifyVariant();
  const qtyCm = this.getBilledQtyCm(v);             // cm facturés
  const unitCents = this.getUnitPriceCents();       // centimes / cm
  const supplCents = Number(this.S.optionsTotalCents || 0);

  const baseCents = qtyCm * unitCents;
  const oneCents = baseCents + supplCents;

  return Math.max(0, Math.round(oneCents));
}

,
// 2️⃣ MODIFIER `buildLineItemProperties()` pour inclure le prix
async buildLineItemProperties() {
  const props = {};
  const txt = (id) => (document.getElementById(id)?.innerText || '').trim();

  const forme = document.querySelector('#td-forme .td-forme-text')?.textContent?.trim()
    || txt('td-forme');
  const ep = txt('td-epaisseur');
  const longueur = txt('quantite_dimensions');
  const options = this.getOptionsTextForCart();
  const prix = txt('td-prix-total');

  if (forme) props['Forme'] = forme;
  if (ep) props['Épaisseur'] = ep;
  if (longueur) props['Longueur totale'] = longueur;
  if (options && options !== '—') props['Options'] = options;
  /* ⚠️ Propriété masquée (préfixe "_") : elle annoncerait un montant différent
     de celui facturé sur la ligne dès qu'il y a des suppléments. */
  if (prix && prix !== '—') props['_prix_total'] = prix;

  const fin = this.variantsMeta?.[this.S.variant]?.name;
  if (fin) props['Finition'] = fin;

  const uid =
  (window.crypto && crypto.randomUUID)
    ? crypto.randomUUID()
    : (`${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random().toString(16).slice(2)}`);

/* ⚠️ Propriétés techniques masquées (préfixe "_") : invisibles pour le client
   au panier, au checkout et sur la commande, mais toujours lisibles côté admin
   et exploitables en Liquid via item.properties._UID. */
props['_UID'] = uid;
props['_cfg_instance'] = uid; // même valeur, garantit l'unicité de la ligne

  props['_qte_commande'] = String(this.S.orderQty || 1);


  /* ══════════════════════════════════════════════════════════════════════
     APERÇU DE CONFIGURATION — boucle de dégradation
     ══════════════════════════════════════════════════════════════════════
     Shopify limite une valeur de propriété à 65 535 caractères. L'ancien
     code générait une seule image en 900 px / qualité 0,55 et l'abandonnait
     SANS AUCUN MESSAGE au-delà de 60 000 caractères — ce qui est le cas de
     toutes les finitions texturées (bois, marbre, béton). On payait donc le
     coût de génération pour, la plupart du temps, aucune image.

     On essaie désormais des réglages de plus en plus légers jusqu'à passer
     sous la limite : il y a quasiment toujours une image jointe.
     ══════════════════════════════════════════════════════════════════════ */
  const PREVIEW_MAX_CHARS = 55000;
  const PREVIEW_STEPS = [
    { maxWidth: 900, quality: 0.55 },
    { maxWidth: 760, quality: 0.45 },
    { maxWidth: 620, quality: 0.38 },
    { maxWidth: 500, quality: 0.30 },
    { maxWidth: 400, quality: 0.25 }
  ];

  try {
    let imageDataUrl = null;
    let usedStep = null;

    for (const step of PREVIEW_STEPS) {
      const candidate = await EXPORT.generatePreviewImage({
        state: this.S,
        variantsMeta: this.variantsMeta,
        getVariantName: (id) => this.variantsMeta?.[id]?.name || '',
        maxWidth: step.maxWidth,
        quality: step.quality
      });
      if (!candidate) break;                       // génération impossible : inutile d'insister
      imageDataUrl = candidate;
      usedStep = step;
      if (candidate.length <= PREVIEW_MAX_CHARS) break;  // ça rentre : on garde
    }

    if (imageDataUrl && imageDataUrl.length <= PREVIEW_MAX_CHARS) {
      props['_preview_image_url'] = imageDataUrl;
      props['_preview_meta'] = `${usedStep.maxWidth}px q${usedStep.quality} · ${imageDataUrl.length}c`;
    } else if (imageDataUrl) {
      // Échec APRÈS dégradation maximale : on trace au lieu d'abandonner en silence.
      props['_preview_skipped'] = `trop volumineux (${imageDataUrl.length} caracteres)`;
      console.warn('⚠️ Aperçu non joint : ' + imageDataUrl.length + ' caractères après dégradation maximale.');
    } else {
      props['_preview_skipped'] = 'generation impossible';
    }
  } catch (e) {
    props['_preview_skipped'] = 'erreur de generation';
    console.warn('⚠️ Aperçu impossible (on continue sans) :', e);
  }

  // ✅ infos techniques
  const qtyCm = Number(this.S.qtyCm || 0);
  const totalCents = Number(this.S.totalCents || 0);
  if (qtyCm) props['_qty_cm'] = String(qtyCm);
  if (totalCents) props['_total_cents'] = String(totalCents);

  // ✅ Évier
  if (this.S.sink && this.S.sink.sinkId) {
    const sinkCfg = this.getSinkConfig(this.S.sink.sinkId);
    if (sinkCfg) {
      props['Évier'] = `${sinkCfg.label} (${sinkCfg.width_mm}×${sinkCfg.depth_mm}mm)`;
      const segs = this.getSegmentsForLayout();
      const segLabel = segs.find(s => s.id === this.S.sink.segment)?.label || this.S.sink.segment;
      /* lot « messages 2 », N24 : les bords sont ceux des champs de la fenêtre (_getSinkLabels : offsetLeftMm = champ « left »,
         offsetBackMm = champ « top ») ; N26 : position du mitigeur en clair */
      const sl = typeof this._getSinkLabels === 'function' ? this._getSinkLabels(this.S.sink.segment) : { left: 'Gauche', top: 'Arrière' };
      const bord = (w) => ({ Arrière: 'arrière', Avant: 'avant', Gauche: 'gauche', Droite: 'droit' })[w] || String(w || '').toLowerCase();
      props['Position évier'] = `${segLabel}, à ${this.S.sink.offsetLeftMm} mm du bord ${bord(sl.left)} et à ${this.S.sink.offsetBackMm} mm du bord ${bord(sl.top)}`;
      if (this.S.sink.faucet) {
        const posLabels = { 'back-left': 'à l\'arrière à gauche', 'back-center': 'à l\'arrière au centre', 'back-right': 'à l\'arrière à droite' };
        props['Mitigeur'] = `Oui, ${posLabels[this.S.sink.faucetPosition] || 'à l\'arrière au centre'}`;
      }
    }
  }

  return props;
},


updateAddToCartButtonState() {
  const btn = document.getElementById('btn-add-cart');
  if (!btn) return;

  // ✅ on ne bloque plus le clic (c’était la source du "bouton pas cliquable")
  btn.disabled = false;
  btn.removeAttribute('disabled');
},

// 3️⃣ MODIFIER `bindAddToCartButton()` - section addon
bindAddToCartButton() {
  if (window.__CFG_ADD_BOUND__) return;
  window.__CFG_ADD_BOUND__ = true;

  if (this._addToCartBound) return;
  this._addToCartBound = true;
  // ✅ Capture = on passe AVANT les scripts du thème qui pourraient rediriger vers /cart
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#btn-add-cart');
    if (!btn) return;

    // ✅ Stop net toute logique du thème sur CE clic
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }

    // ✅ recalcul avant ajout
    this.updateTdOptionsList();
    this.updateTdEpaisseur();
    this.updateTdLongueurTotal();
    this.updateTdPrixTotal();
    await new Promise(requestAnimationFrame);

    const v = this.getSelectedShopifyVariant();
    if (!v || !v.id) {
      alert("Variante Shopify introuvable (id manquant).");
      return;
    }
    if (v.available === false) {
      alert("Cette variante est indisponible. Choisis une autre finition.");
      return;
    }

  const q = Math.max(1, parseInt(this.S.orderQty, 10) || 1);
const qtyUnits = this.getBilledQtyCm(v); // cm
const qtyUnitsTotal = qtyUnits * q;


    btn.disabled = true;
    const oldText = btn.textContent;
    btn.textContent = 'Ajout...';

    try {
      const properties = await this.buildLineItemProperties();

      // normalise en string (Shopify)
      Object.keys(properties).forEach(k => {
        if (properties[k] == null) delete properties[k];
        else properties[k] = String(properties[k]);
      });

const items = [{
  id: v.id,
  quantity: qtyUnitsTotal,
  properties
}];

      // ✅ CALCUL ADDON (delta = suppléments)
      const addonId     = Number(window.CONFIGURATOR_CONFIG?.addonVariantId || 0);      // variante 0,01 €
      const addonIdEuro = Number(window.CONFIGURATOR_CONFIG?.addonVariantIdEuro || 0);  // variante 1,00 € (optionnelle)
    const unitPriceCents = Number(v.price) || 0;
const baseLineCents = unitPriceCents * qtyUnits; // ✅ 1 seule pièce (pas * q)

const totalOneCents = (baseLineCents + Number(this.S.optionsTotalCents || 0));
const totalCalculatedCents = Math.round(totalOneCents * q);

const deltaCents = Math.max(0, totalCalculatedCents - (baseLineCents * q));


      /* ══════════════════════════════════════════════════════════════════════
         AJUSTEMENT PRIX — 1 ligne par palier, plus AUCUN découpage en tranches
         ══════════════════════════════════════════════════════════════════════
         Ancien comportement : 1 ligne par tranche de 10 € (_chunk différent
         à chaque itération => Shopify ne fusionnait jamais les lignes).
           138,00 € => 14 lignes / 13 800 articles.

         Nouveau : paliers décroissants 1,00 € puis 0,01 €.
           138,00 € => 1 ligne  /   138 articles
            28,80 € => 2 lignes /   108 articles
         Le montant encaissé est strictement identique (au centime près).

         ⚠️ Aucune propriété variable n'est posée sur les lignes d'ajustement :
            c'est ce qui permet à Shopify de fusionner deux lignes identiques
            au lieu de les empiler.
         ══════════════════════════════════════════════════════════════════════ */
      if (deltaCents > 0) {
        const parentUid = String(properties._UID || '');

        // Libellé de rattachement affiché au client sous la ligne d'ajustement,
        // pour qu'il comprenne à quelle pièce le supplément correspond.
        const addonLabel = [
          properties['Forme'] || '',
          properties['Longueur totale'] || '',
          properties['Finition'] || ''
        ].filter(Boolean).join(' · ') || 'Plan de travail sur mesure';

        // Ajoute une ligne d'ajustement. Retourne la valeur couverte, en centimes.
        const pushAddon = (variantId, units, unitCents) => {
          if (!variantId || units <= 0) return 0;
          items.push({
            id: variantId,
            quantity: units,
            properties: {
              'Se rapporte à': addonLabel,
              _addon: '1',
              _parent_uid: parentUid
            }
          });
          return units * unitCents;
        };

        let remaining = deltaCents;

        // Aucune variante "centime" configurée -> arrondi à l'euro supérieur
        // (jamais en défaveur du marchand, écart maximal +0,99 €).
        if (addonIdEuro > 0 && addonId <= 0) {
          remaining = Math.ceil(remaining / 100) * 100;
        }

        if (addonIdEuro > 0) {
          remaining -= pushAddon(addonIdEuro, Math.floor(remaining / 100), 100);
        }
        if (addonId > 0) {
          remaining -= pushAddon(addonId, remaining, 1);
        }

        if (remaining > 0) {
          console.warn(
            '⚠️ Ajustement non couvert :', remaining,
            'centimes. Renseignez le Variant ID addon (0,01 €) dans les réglages de la section.'
          );
        }
      }

      /* ══════════════════════════════════════════════════════════════════════
         ORDRE D'AFFICHAGE DES LIGNES
         Shopify affiche les lignes ajoutées dans un même appel /cart/add.js
         dans l'ORDRE INVERSE de leur position dans le tableau `items`.
         On envoie donc le tableau inversé (ajustements d'abord, plan de travail
         en dernier) pour que le client voie le plan de travail EN PREMIER et
         les options en dessous.
         ══════════════════════════════════════════════════════════════════════ */
      const payload = items.slice().reverse();

      // ✅ DEBUG: ce qu'on envoie
      if (window.CART_DEBUG) window.CART_DEBUG.logItems(payload);

      const r = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload })
      });

      const raw = await r.text();
      let parsed = null;
      try { parsed = JSON.parse(raw); } catch (_) {}

      // ✅ BLOC COMPLET demandé
      if (!r.ok) {
        const msg =
          (parsed && (parsed.description || parsed.message || parsed.errors)) ||
          raw ||
          'Cart Error';
        throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
      }

      // ✅ DEBUG: panier réel après ajout
      if (window.CART_DEBUG) await window.CART_DEBUG.readCart();

      // ✅ Rester sur la page : ouvrir drawer si dispo, sinon message
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        alert('Ajouté au panier ✅');
      }

    } catch (err) {
      console.error(err);
      alert("Erreur ajout au panier : " + (err.message || err));
    } finally {
      btn.disabled = false;
      btn.textContent = oldText;
    }
  }, true); // ✅ capture
},



syncLayoutFromDOMAndRender() {
  const activeBtn = document.querySelector('.layout-btn.active');
  if (activeBtn?.dataset?.layout) this.S.layout = activeBtn.dataset.layout;

  this.applyLayoutUI();

  if (typeof updateTdForme === 'function') updateTdForme();
  if (typeof updateRecapShapeIcon === 'function') updateRecapShapeIcon();

  // au cas où (menu edge types)
  if (this._eff?.edgeTypes) CFG_applyEdgeTypes(this, this._eff.edgeTypes);

  this.render();
},


setOrderQty(n) {
  const v = Math.max(1, parseInt(n, 10) || 1);
  this.S.orderQty = v;

  const input = document.getElementById('qty-input');
  if (input) input.value = String(v);

  // recalcul prix affiché
  this.updateTdPrixTotal();
},

initQtyUI() {
  const input = document.getElementById('qty-input');
  if (!input) return;

  const apply = () => {
    const v = Math.max(1, parseInt(input.value, 10) || 1);
    this.S.orderQty = v;

    this.updateTdPrixTotal();
    this.updateDisplayedMultiTotal();
  };

  // init
  input.value = String(this.S.orderQty || 1);
  apply();

  input.addEventListener('input', apply);
  input.addEventListener('change', apply);
  input.addEventListener('blur', apply);
}
,

resetEdgesAndBandingOnly() {
  // Réinitialiser tous les types de bords à 'straight'
  this.S.edges = Object.keys(this.S.edges || {}).reduce((acc, key) => {
    acc[key] = 'straight';
    return acc;
  }, {});

  // Réinitialiser les paramètres de bevel/notch
  this.S.bevel = {};
  this.S.notch = {};

  // Réinitialiser les chants (edgeBanding)
  this.S.edgeBanding = {};
  this.S.edgeBandingByEdge = {};

  // ✅ Réinitialiser l'angle intérieur à 90°
  this.S.innerAngle = 90;
},



resetDimensionsForLayout() {
  const layout = this.S.layout;
  const defaultLength = 2400;
  const defaultDepth = 600;

  // Réinitialiser les dimensions selon la forme
  if (layout === 'linear') {
    this.S.L = defaultLength;
    this.S.P = defaultDepth;
  }
  else if (layout === 'angle') {
    this.S.L1 = defaultLength;
    this.S.P1 = defaultDepth;
    this.S.L2 = Math.floor(defaultLength * 0.5);
    this.S.P2 = defaultDepth;
  }
  else if (layout === 'u-shape') {
    this.S.Lg = Math.floor(defaultLength * 0.5);
    this.S.Lc = Math.max(100, defaultLength * 0.75);
    this.S.Ld = Math.floor(defaultLength * 0.5);
    this.S.Pl = defaultDepth;
    this.S.Pc = defaultDepth;
    this.S.Pr = defaultDepth;
  }
  else if (layout === 'g-shape') {
    this.S.Gtop = Math.floor(defaultLength * 1.25);
    this.S.Gleft = Math.floor(defaultLength * 0.75);
    this.S.Gright = Math.floor(defaultLength * 0.75);
    this.S.Greturn = Math.floor(defaultLength * 0.5);
    this.S.Pgtop = defaultDepth;
    this.S.Pgleft = defaultDepth;
    this.S.Pgright = defaultDepth;
    this.S.Pgreturn = defaultDepth;
  }
},



      init(){
        // ============================================
        // VÉRIFICATION DE L'ACTIVATION
        // ============================================
        if (window.CONFIGURATOR_CONFIG && !window.CONFIGURATOR_CONFIG.enabled) {
          console.log('⛔ Configurateur désactivé pour ce produit');
          // Masquer le configurateur
          const configContainer = document.querySelector('.config');
          if (configContainer) {
            configContainer.style.display = 'none';
          }
          return;
        }
        // ============================================
        // INITIALISATION DES ÉLÉMENTS DOM
        // ============================================
        this.svg=document.getElementById('svg');
        this.dims=document.getElementById('dims');
        this.stage=document.getElementById('stage');
        this.menu=document.getElementById('edge-menu');
        this.edgePopup=document.getElementById('edge-dims-popup');
        this.menuTarget=null;
        // ============================================
        // CHARGEMENT DU PRODUIT SHOPIFY
        // ============================================
        if(window.__PRODUCT__ && !this.product){
          this.setShopifyProduct(window.__PRODUCT__);
        }
        this.initVariantsUI();
        // ============================================
        // CHARGEMENT DES VALEURS PAR DÉFAUT
        // ============================================
        if (window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.defaults) {
          const defaults = window.CONFIGURATOR_CONFIG.defaults;
          console.log('⚙️ Chargement des valeurs par défaut:', defaults);
          // Dimensions linéaires
          this.S.L = defaults.length;
          this.S.P = defaults.depth;
          // Dimensions angle
          this.S.L1 = defaults.length;
          this.S.P1 = defaults.depth;
          this.S.L2 = Math.floor(defaults.length * 0.5);
          this.S.P2 = defaults.depth;
          // Dimensions U
          this.S.Pl = defaults.depth;
          this.S.Pc = defaults.depth;
          this.S.Pr = defaults.depth;
          this.S.Lc = Math.max(100, defaults.length * 0.75);
          this.S.Lg = Math.floor(defaults.length * 0.5);
          this.S.Ld = Math.floor(defaults.length * 0.5);
          // Dimensions G
          this.S.Gtop = Math.floor(defaults.length * 1.25);
          this.S.Pgtop = defaults.depth;
          this.S.Pgleft = defaults.depth;
          this.S.Pgright = defaults.depth;
          this.S.Pgreturn = defaults.depth;
          this.S.Gleft = Math.floor(defaults.length * 0.75);
          this.S.Gright = Math.floor(defaults.length * 0.75);
          this.S.Greturn = Math.floor(defaults.length * 0.5);
          // Épaisseur
          this.S.thk = parseInt(defaults.thickness);

   
        }

       this.initLegsUI();
          this.updateLegsButtonState();
   

  {
  const eff = CFG_getEffectiveRules();
  this._eff = eff;

  /* ── Masquer bouton jambage si désactivé pour cette collection ── */
  {
    const legsBtn = document.getElementById('btn-add-legs');
    if (legsBtn) {
      /* enableLegs vient du collectionRules brut (pas dans eff) */
      const cfg = window.CONFIGURATOR_CONFIG || {};
      const rules = Array.isArray(cfg.collectionRules) ? cfg.collectionRules : [];
      const matchedId = Number(window.MATCHED_COLLECTION_ID || 0);
      const productCols = (window.PRODUCT_COLLECTION_IDS || []).map(Number);
      let matchedRule = matchedId ? rules.find(r => Number(r?.collectionId||0) === matchedId) : null;
      if (!matchedRule) matchedRule = rules.find(r => { const c = Number(r?.collectionId||0); return c && productCols.includes(c); });
      const legsEnabled = matchedRule ? matchedRule.enableLegs : true;
      legsBtn.style.display = (legsEnabled === false) ? 'none' : '';
    }
  }
  
  // ✅ Évier : init APRÈS _eff (car isSinkEnabled dépend de _eff.sinkRule)
  this.initSinkUI();
  this.updateSinkButtonState();
  

  // ✅ Applique le filtrage (boutons formes + menu types de bords)
  CFG_applyLayouts(this, eff.layouts);
  CFG_applyEdgeTypes(this, eff.edgeTypes);

  // ✅ Sync du layout actif vers le state (important si une seule forme visible)
  const activeBtn = document.querySelector('.layout-btn.active');
  this.S.layout = activeBtn?.dataset?.layout || 'linear';

  // ✅ Met l'UI en cohérence (orientation/jonctions visibles/cachées)
  this.applyLayoutUI();

  // ❌ PAS de this.render() ici (on laisse le render() final de init() gérer le vrai rendu)
}



// ============================================
// MASQUAGE DES OPTIONS D'AFFICHAGE
// ============================================
if (window.CONFIGURATOR_CONFIG && window.CONFIGURATOR_CONFIG.display) {
  const display = window.CONFIGURATOR_CONFIG.display;

  // Masquer le sélecteur d'orientation d'angle si désactivé
  if (!display.angleOrientation) {
    const angleOrientSection = document.getElementById('angle-orientation-section');
    if (angleOrientSection) angleOrientSection.style.display = 'none';
    /* V2 : masquer aussi le bouton orientation dans la barre */
    const barBtnOrient = document.getElementById('bar-btn-orientation');
    if (barBtnOrient) barBtnOrient.style.display = 'none';
  }

  // Masquer le sélecteur d'épaisseur si désactivé
  if (!display.thicknessSelector) {
    /* V2 : masquer le bouton dans la barre */
    const barBtnThk = document.getElementById('bar-btn-thickness');
    if (barBtnThk) barBtnThk.style.display = 'none';
    /* Rétro-compat V1 */
    const thkSections = document.querySelectorAll('.side-section');
    thkSections.forEach(section => {
      const h3 = section.querySelector('h3');
      if (h3 && h3.textContent.includes('Épaisseur')) {
        section.style.display = 'none';
      }
    });
  }
}



this.renderThicknessUI();


// ============================================
// ÉVÉNEMENTS - BOUTONS DE LAYOUT
// ============================================
// Dans l'écouteur des boutons de layout :
document.querySelectorAll('.layout-btn').forEach(b => b.addEventListener('click', () => {
  document.querySelector('.layout-btn.active')?.classList.remove('active');
  b.classList.add('active');

  const newLayout = b.dataset.layout;
  const newDir = b.dataset.dir || '';
  const oldLayout = this.S.layout;

  this.S.layout = newLayout;

  // Appliquer la direction si pertinente
  if (newLayout === 'angle' && newDir) {
    this.S.angleDir = newDir;
  } else if (newLayout === 'g-shape' && newDir) {
    this.S.gDir = newDir;
  }

  // ✅ Réinitialiser les bords, chants ET dimensions
  this.resetEdgesAndBandingOnly();
  if (newLayout !== oldLayout) {
    this.resetDimensionsForLayout();
  }

  this.applyLayoutUI();

  if (this._eff?.edgeTypes) CFG_applyEdgeTypes(this, this._eff.edgeTypes);

  this.render();
}));


// Dans l'écouteur des boutons d'orientation (angle/g) :
// (conservé pour compatibilité si les radios existent encore dans le DOM)
document.querySelectorAll('input[name="angleDir"]').forEach(r => r.addEventListener('change', () => {
  this.S.angleDir = document.querySelector('input[name="angleDir"]:checked').value;

  // ✅ Réinitialiser uniquement les bords et chants
  this.resetEdgesAndBandingOnly();

  this.render();
}));

document.querySelectorAll('input[name="gDir"]').forEach(r => r.addEventListener('change', () => {
  this.S.gDir = document.querySelector('input[name="gDir"]:checked').value;

  // ✅ Réinitialiser uniquement les bords et chants
  this.resetEdgesAndBandingOnly();

  this.render();
}));

        // ============================================
        // ÉVÉNEMENTS - TYPE DE JONCTION
        // ============================================
        document.querySelectorAll('input[name="junction"]').forEach(r=>r.addEventListener('change',()=>{
          this.S.junctionType=document.querySelector('input[name="junction"]:checked').value;
          this.render();
        }));
        // ============================================
        // ÉVÉNEMENTS - CLICS SUR LA SCÈNE
        // ============================================
        this.stage.addEventListener('click',e=>{
          if( !e.target.closest('.edge-menu') && !(e.target.classList&&e.target.classList.contains('hit')) && !e.target.classList.contains('inner-angle-overlay') )
            this.closeMenu();
          if( !e.target.closest('.edge-dims-popup') && !e.target.classList.contains('edge-overlay') && !e.target.classList.contains('inner-angle-overlay') )
            this.closeEdgePopup();
        });
        // ============================================
        // ÉVÉNEMENTS - MENU DE SÉLECTION DE BORDS
        // ============================================
    this.menu.addEventListener('click', (e) => {
  const btn = e.target.closest('.em-opt');
  if (!btn || !this.menuTarget) return;

  /* Sans ce stopPropagation le clic remonte jusqu'au document, dont le
     gestionnaire « clic exterieur » referme aussitot la popup que l'on
     vient d'ouvrir : le parametrage clignotait et disparaissait. */
  e.stopPropagation();

  const edgeKey = this.menuTarget;
  /* Lus AVANT closeMenu() : ils servent a rouvrir la popup sur le bon coin. */
  const mRect   = this.menuRect;
  const mCorner = this.menuCorner;
  const type = btn.getAttribute('data-type');

  // sécurité collection
  if (type !== 'straight' && this._eff?.edgeTypes && this._eff.edgeTypes[type] !== true) return;

  // ✅ SI "DROIT" : on passe par clearEdgeType => décoche auto-bandings
  if (type === 'straight') {
    this.clearEdgeType(edgeKey);
    this.closeMenu();
    this.render();
    return;
  }

  // ✅ init des params pour éviter crash au render
  if (type === 'bevel') {
    this.S.bevel = this.S.bevel || {};
    if (!this.S.bevel[edgeKey]) this.S.bevel[edgeKey] = { dx: 50, dy: 50 };
  }
  if (type === 'notch') {
    this.S.notch = this.S.notch || {};
    if (!this.S.notch[edgeKey]) this.S.notch[edgeKey] = { dx: 100, dy: 100, offset: 0 };
  }
  if (type === 'round1') {
    if (!this.S.roundRadius) this.S.roundRadius = 30;
  }

  // ✅ appliquer le type
  this.S.edges[edgeKey] = type;

  this.closeMenu();
  this.render();

  /* OUVERTURE AUTOMATIQUE DE LA SAISIE — choisir un type de bord sans
     pouvoir le dimensionner dans la foulee obligeait a re-cliquer sur le
     coin. Exception : le demi-rond, dont le rayon vaut la moitie de la
     plus petite cote et n'est donc pas saisissable ; ouvrir une popup
     sans champ n'aurait aucun sens.
     mRect est indispensable : showEdgePopup() en tire les bornes reelles. */
  if (type !== 'semi' && mRect) {
    this.showEdgePopup(mRect, mCorner, edgeKey, e);
  }
});


        // ============================================
        // FONCTION DE MISE À JOUR DU MENU
        // ============================================
        this.updateMenuSelection=()=>{
          if(!this.menuTarget) return;
          const cur=this.S.edges[this.menuTarget];
          const ep = this._eff?.edgePricesEuro || {};
          this.menu.querySelectorAll('.em-opt').forEach(btn=>{
            const t=btn.getAttribute('data-type');
            const isSel = (t === cur);
            btn.classList.toggle('active', isSel);
            /* ── Prix dynamiques ── */
            const priceEl = btn.querySelector('.em-price');
            if (priceEl) {
              const euros = (t === 'straight') ? 0 : (Number(ep[t]) || 0);
              priceEl.textContent = euros > 0 ? `+${euros}€` : (t === 'straight' ? '+0€' : 'inclus');
            }
          });
        };
        // ============================================
        // INITIALISATION DES CHANTS
        // ============================================
        this.setupEdgeBanding();
        


        this.render();
        this.bindAddToCartButton();
        this.updateAddToCartButtonState();
        this.updateDisplayedMultiTotal();
   
        this._ro=new ResizeObserver(()=>this.updateDims());
        this._ro.observe(this.stage);
        this._ro.observe(this.svg);
        addEventListener('resize',()=>this.updateDims());

        /* ── Orientation change → full re-render ── */
        let orientTimer = null;
        const handleOrientChange = () => {
          clearTimeout(orientTimer);
          orientTimer = setTimeout(() => {
            this.render();
          }, 300);
        };
        addEventListener('orientationchange', handleOrientChange);
        /* iOS Safari: also listen to resize with debounce for orientation */
        let resizeTimer = null;
        addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.render();
          }, 400);
        });
        // ============================================
        // LOG FINAL
        // ============================================
        console.log('🎨 État initial du configurateur:', {
          layout: this.S.layout,
          dimensions: {
            L: this.S.L,
            P: this.S.P,
            thickness: this.S.thk
          },
          variant: this.S.variant
        });
      },
      initVariantsUI(){
        const container=document.getElementById('variants-container');
        if(!container) return;
        container.innerHTML='';
        let items=[];
        if(this.colorOptionIndex>=0){
          const opt=this.options[this.colorOptionIndex];
          items = (opt.values||[]).map(v=>{
            const id=this.normalizeId(v.value);
            const sw=this.valueToSwatch[id]||{};
            const img=this.valueToVariantImage[id] || sw.image || null;
            const col=sw.color || this.aplatFromData(v.value) || this.guessFallbackFromText(v.value);
            this.ensureVariantPatterns(id,col);
            this.variantsMeta[id]={name:v.value,fallbackColor:col};
            return {
              id,
              name:v.value,
              imageUrl:img,
              fallbackColor:col
            };
          });
        }else if(this.shopifyVariants.length){
          const seen=new Set();
          this.shopifyVariants.forEach(v=>{
            const name=(v.option1||v.title||'').trim();
            const id=this.normalizeId(name);
            if(!id||seen.has(id)) return;
            seen.add(id);
            const img=v.featured_image?.src || v.featured_image || v.featured_media?.preview_image?.src || v.image?.src || null;
            const col=this.aplatFromData(name) || this.guessFallbackFromText(name);
            this.ensureVariantPatterns(id,col);
            this.variantsMeta[id]={name,fallbackColor:col};
            items.push({id,name,imageUrl:img,fallbackColor:col});
          });
        }else{
          items=[{id:'default',name:'Texture',imageUrl:`${this.imageBaseUrl}default.jpg`,fallbackColor:'#e5e7eb'}];
          items.forEach(v=>{
            this.ensureVariantPatterns(v.id,v.fallbackColor);
            this.variantsMeta[v.id]={name:v.name,fallbackColor:v.fallbackColor};
          });
        }

        if (!items.length) {
  items = [{ id: 'default', name: 'Texture', imageUrl: null, fallbackColor: '#e5e7eb' }];
  this.ensureVariantPatterns('default', '#e5e7eb');
  this.variantsMeta['default'] = { name: 'Texture', fallbackColor: '#e5e7eb' };
}

        /* ══════ TRI ALPHABÉTIQUE DES DÉCORS ══════
           L'ordre des valeurs d'option vient de Shopify, où il est purement
           historique : un décor ajouté hier se retrouve en fin de liste. Sur
           trente teintes, un client ne cherche pas « la dernière ajoutée »,
           il cherche un nom. On trie donc à l'affichage.

           localeCompare en locale française classe correctement les accents
           — Chêne se range avec Chene et non après Z — et l'option numeric
           fait que « Gris 10 » suit « Gris 9 » au lieu de le précéder, ce
           qu'un tri de chaînes brut ferait.

           La variante par défaut est mémorisée AVANT le tri. Sans cela, la
           finition affichée au chargement deviendrait la première dans
           l'alphabet, et changerait toute seule le jour où tu ajoutes un
           décor commençant par A. L'ordre d'affichage change, la sélection
           initiale ne bouge pas. */
        const defautId = items[0] ? items[0].id : null;
        items.sort(function (a, b) {
          return String(a.name).localeCompare(String(b.name), 'fr', {
            numeric: true,
            sensitivity: 'base'
          });
        });


        // ✅ Pré-sélection variante depuis l'URL (?variant=SHOPIFY_ID)
        if (!this.S.variant) {
          const urlVariantId = new URLSearchParams(window.location.search).get('variant');
          if (urlVariantId && this.shopifyVariants) {
            const sv = this.shopifyVariants.find(v => String(v.id) === String(urlVariantId));
            if (sv) {
              const colorValue = this.colorOptionIndex >= 0
                ? sv[`option${this.colorOptionIndex + 1}`]
                : (sv.option1 || sv.title || '');
              if (colorValue) {
                const matchId = this.normalizeId(colorValue);
                if (items.some(i => i.id === matchId)) {
                  this.S.variant = matchId;
                }
              }
            }
          }
        }
        // Fallback : première variante
        if (!this.S.variant && defautId) this.S.variant = defautId;
        items.forEach(variant=>{
          const label=document.createElement('label');
          label.className=`variant-opt ${this.S.variant===variant.id?'active':''}`;
          label.dataset.variant=variant.id;
          const input=document.createElement('input');
          input.type='radio';
          input.name='variant';
          input.value=variant.id;
          input.checked=this.S.variant===variant.id;
          const preview=document.createElement('span');
          preview.className='variant-preview';
          if(variant.imageUrl){
            preview.style.backgroundImage=`url(${variant.imageUrl})`;
            preview.style.backgroundSize='cover';
            preview.style.backgroundPosition='center';
          }else{
            preview.style.background=variant.fallbackColor||'#e5e7eb';
          }
          const name=document.createElement('span');
          name.className='variant-name';
          name.textContent=variant.name;
          label.appendChild(input);
          label.appendChild(preview);
          label.appendChild(name);
          container.appendChild(label);
          label.addEventListener('click',()=>{
            document.querySelectorAll('.variant-opt').forEach(o=>o.classList.remove('active'));
            label.classList.add('active');
            this.S.variant=variant.id;
            input.checked=true;
            this.ensureVariantPatterns(variant.id,variant.fallbackColor);
            this.render();
            setTimeout(() => ConfigBar.close(), 150);
          });
        });
      },
      clear(){
        // 🔥 NETTOYER COMPLÈTEMENT LE SVG
        const defs = this.svg.querySelector('defs');
        const defsContent = defs ? defs.outerHTML : '';
        this.svg.innerHTML = defsContent;
        this.dims.innerHTML='';
        this.dimOffsets={top:60,bottom:60,left:60,right:60};
      },
      svgToClient(x,y){
        const pt=this.svg.createSVGPoint();
        pt.x=x;pt.y=y;
        const m=this.svg.getScreenCTM();
        if(!m){
          const vb=this.svg.viewBox.baseVal,
                r=this.svg.getBoundingClientRect();
          return{
            px:r.left+(x/vb.width)*r.width,
            py:r.top +(y/vb.height)*r.height
          }
        }
        const p=pt.matrixTransform(m);
        return {px:p.x,py:p.y};
      },
      pxLen(x1,y1,x2,y2){
        const a=this.svgToClient(x1,y1),
              b=this.svgToClient(x2,y2);
        return Math.hypot(b.px-a.px,b.py-a.py);
      },
      place(el, x, y) {
        const p = this.svgToClient(x, y);
        const host = this.dims.getBoundingClientRect();
        el.style.left = (p.px - host.left) + 'px';
        el.style.top = (p.py - host.top) + 'px';
        return { left: p.px - host.left, top: p.py - host.top };
      },
      addDim(
  x1, y1, x2, y2,
  {
    txt,
    editable = true,
    vertical = false,
    side = 'top',
    onCommit,
    isEdge = false,
    isDepth = false,
    calculated = false,
    subdivisions = null,
    customClass = ''
  }
) {
  if (isEdge) return;

  const b = document.createElement('div');
  const calcClass = calculated ? ' calculated' : '';
  const baseClass =
    'dim ' +
    (vertical ? 'v' : 'h') +
    ' pos-' +
    (vertical ? (side === 'right' ? 'right' : 'left') : (side === 'bottom' ? 'bottom' : 'top')) +
    (editable ? '' : ' readonly') +
    calcClass;

  b.className = baseClass + ' dim-std';
  Object.assign(b.dataset, { x1, y1, x2, y2, vert: vertical ? '1' : '0' });

  const len = this.pxLen(x1, y1, x2, y2);
  if (vertical) b.style.height = len + 'px';
  else b.style.width = len + 'px';

  if (txt && txt.trim() !== '') {
    const track = document.createElement('div');
    track.className = 'track-std';
    b.appendChild(track);
  }

  const label = document.createElement('div');
  label.className = customClass ? customClass : 'label';

  if (editable) {
    const show = document.createElement('span');
    show.textContent = txt;

    const cur = () =>
      ((show.textContent.match(/(\d+\.?\d*)(?!.*\d)/) || [, ''])[1]) || '';

    show.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeMenu();
      this.closeEdgePopup();

      const currentVal = parseInt(cur(), 10) || 600;

      // ✅ CAS PROFONDEUR uniquement
      if (isDepth === true) {
        // ✅ si filtre profondeur OFF -> popup normale (input)
        if (!(this._eff?.depthRule?.enabled === true)) {
          const popup = this.edgePopup;
          const titleEl = document.getElementById('edge-popup-title');
          const content = document.getElementById('edge-popup-content');
          if (!popup || !titleEl || !content) return;

         const minD = Number(this._eff?.depthLimits?.min ?? 300);
const maxD = Number(this._eff?.depthLimits?.max ?? 2000);

titleEl.textContent = `Profondeur (${minD}–${maxD} mm)`;

/* Prix dynamique profondeur */
const CONFIG_D = window.CONFIGURATOR_CONFIG || {};
const depthStds = CONFIG_D.depthStandards || [];
const depthCust = CONFIG_D.depthCustomRanges || [];
const getDepthPrice = (d) => {
  const std = depthStds.find(o => Number(o.depth_mm) === d);
  if (std) return Number(std.extraPrice || 0);
  const cst = depthCust.find(o => d >= Number(o.min_mm||0) && d <= Number(o.max_mm||99999));
  if (cst) return Number(cst.extraPrice || 0);
  return 0;
};
const depthPricePm = getDepthPrice(currentVal);
const depthPriceHtml = depthPricePm > 0 ? `<small class="em-price">+${depthPricePm}€/m</small>` : '';

content.innerHTML = `
  <div class="input-group">
    <label>mm :</label>
    <input type="number" id="depth-normal-input" value="${currentVal}" min="${minD}" max="${maxD}">
    <span>mm</span>
  </div>
  ${depthPriceHtml}
  <button id="depth-normal-apply">Appliquer</button>
`;

/* Mettre à jour prix quand la valeur change */
const depthInput = document.getElementById('depth-normal-input');
const priceDisplay = content.querySelector('.em-price');
if (depthInput && priceDisplay) {
  depthInput.addEventListener('input', () => {
    const v = parseInt(depthInput.value, 10) || 0;
    const p = getDepthPrice(v);
    priceDisplay.textContent = p > 0 ? `+${p}€/m` : '';
    priceDisplay.style.display = p > 0 ? '' : 'none';
  });
}


popup.style.left = '50%';
popup.style.top = '50%';
popup.style.transform = 'translate(-50%, -50%)';
popup.classList.remove('hidden');

document.getElementById('depth-normal-apply')?.addEventListener('click', () => {
  const val = parseInt(document.getElementById('depth-normal-input')?.value, 10);
  if (isNaN(val)) return;

  if (val < minD || val > maxD) {
    alert(`La profondeur doit être entre ${minD} et ${maxD} mm`);
    return;
  }

  if (onCommit) onCommit(val);
  this.closeEdgePopup();
  this.render();
});

return;

        }

        // ✅ filtre profondeur ON -> popup boutons
        this.showDepthSelector(currentVal, (newValue) => {
          if (onCommit && newValue > 0) onCommit(newValue);
        });

        return;
      }

      // ✅ CAS NORMAL (longueurs / dims) : popup standard input
      const popup = this.edgePopup;
      const titleEl = document.getElementById('edge-popup-title');
      const content = document.getElementById('edge-popup-content');
      if (!popup || !titleEl || !content) return;

      const minL = Number(this._eff?.lengthLimits?.min ?? 10);
const maxL = Number(this._eff?.lengthLimits?.max ?? 10000);

titleEl.textContent = `Dimension : de ${minL.toLocaleString('fr-FR')} à ${maxL.toLocaleString('fr-FR')} mm`;   /* lot « messages 2 », T2 : forme des aides, espace des milliers ; cp-a11y y met le nom de la cote */

content.innerHTML = `
  <div class="input-group">
    <label>mm :</label>
    <input type="number" id="dim-normal-input" value="${currentVal}" min="${minL}" max="${maxL}">
    <span>mm</span>
  </div>
  <button id="dim-normal-apply">Appliquer</button>
`;


      popup.style.left = '50%';
      popup.style.top = '50%';
      popup.style.transform = 'translate(-50%, -50%)';
      popup.classList.remove('hidden');

      document.getElementById('dim-normal-apply')?.addEventListener('click', () => {
   const val = parseInt(document.getElementById('dim-normal-input')?.value, 10);
if (isNaN(val)) return;

if (val < minL || val > maxL) {
  alert(`La dimension doit être entre ${minL.toLocaleString('fr-FR')} et ${maxL.toLocaleString('fr-FR')} mm`);   /* T1 */
  return;
}

if (onCommit) onCommit(val);
this.closeEdgePopup();
this.render();

      });
    });

    show.style.cursor = 'pointer';
    show.title = isDepth ? 'Cliquez pour choisir une profondeur' : 'Cliquez pour modifier la dimension';

    label.appendChild(show);
  } else {
    label.textContent = txt;
  }

  b.appendChild(label);
  this.dims.appendChild(b);

  this.place(b, (x1 + x2) / 2, (y1 + y2) / 2);

  if (subdivisions && subdivisions.length > 0) {
    this.addSubdivisions(b, subdivisions, vertical);
  }

  return b;
},

      addSubdivisions(dimElement, subdivisions, isVertical) {
        if (!subdivisions || !subdivisions.length) return;
        let pos = 'top';
        if (dimElement.className.includes('pos-bottom')) pos = 'bottom';
        else if (dimElement.className.includes('pos-left')) pos = 'left';
        else if (dimElement.className.includes('pos-right')) pos = 'right';
        const container = document.createElement('div');
        container.className = `dim-subdivisions subdiv-${pos}`;
        const line = document.createElement('div');
        line.className = `subdivision-line subdiv-line-${pos}`;
        container.appendChild(line);
        let cumulativePos = 0;
        subdivisions.forEach((subdiv, index) => {
          const value = subdiv.value;
          const segmentStart = cumulativePos;
          const segmentEnd = index < subdivisions.length - 1 ? subdivisions[index].position : 1;
          const midPos = (segmentStart + segmentEnd) / 2;
          if (index < subdivisions.length - 1) {
            const marker = document.createElement('div');
            marker.className = `subdivision-marker subdiv-marker-${pos}`;
            if (isVertical) {
              marker.style.top = `${subdiv.position * 100}%`;
            } else {
              marker.style.left = `${subdiv.position * 100}%`;
            }
            container.appendChild(marker);
          }
          const label = document.createElement('div');
          label.className = `subdivision-label subdiv-label-${pos}`;
          label.textContent = value;
          if (isVertical) {
            label.style.top = `${midPos * 100}%`;
          } else {
            label.style.left = `${midPos * 100}%`;
          }
          container.appendChild(label);
          cumulativePos = segmentEnd;
        });
        dimElement.appendChild(container);
      },
     
      calculateSubdivisionsWithEdges(totalLength, edgeKeyStart, edgeKeyEnd, axis) {
        const getEdgeDim = (edgeKey) => {
          if (!edgeKey) return 0;
          const t = this.S.edges[edgeKey];
          if (!t || t === 'straight') return 0;
          // demi-rond : pas de sous-dimension
          if (t === 'semi') return 0;
          if (t === 'bevel') {
            const b = this.S.bevel[edgeKey] || {};
            // Utiliser les valeurs par défaut (50) si non définies
            const v = axis === 'x' ? (b.dx || 50) : (b.dy || 50);
            return Math.min(v, totalLength);
          }
          if (t === 'notch') {
            const n = this.S.notch[edgeKey] || {};
            // Utiliser les valeurs par défaut (50) si non définies
            const v = axis === 'x' ? (n.dx || 50) : (n.dy || 50);
            return Math.min(v, totalLength);
          }
          if (t === 'round1') {
            const r = this.S.roundRadius || 30;
            return Math.min(r, totalLength);
          }
          return 0;
        };
        const dStart = getEdgeDim(edgeKeyStart);
        const dEnd = getEdgeDim(edgeKeyEnd);
        const middle = Math.max(0, totalLength - dStart - dEnd);
        const segs = [];
        let acc = 0;
        if (dStart > 0) {
          acc += dStart;
          segs.push({ value: Math.round(dStart), position: acc / totalLength });
        }
        if (middle > 0) {
          acc += middle;
          segs.push({ value: Math.round(middle), position: acc / totalLength });
        }
        if (dEnd > 0) {
          acc += dEnd;
          segs.push({ value: Math.round(dEnd), position: acc / totalLength });
        }
        return segs;
      },
      updateDims(){
        this.dims.querySelectorAll('.dim').forEach(b=>{
          const x1=+b.dataset.x1,
                y1=+b.dataset.y1,
                x2=+b.dataset.x2,
                y2=+b.dataset.y2;
          const len=this.pxLen(x1,y1,x2,y2);
          if(b.dataset.vert==='1') b.style.height=len+'px';
          else b.style.width=len+'px';
          this.place(b,(x1+x2)/2,(y1+y2)/2);
        });
      },
      drawEdgeOverlay(rect, corner, edgeKey) {
        const type = this.S.edges[edgeKey];
        if (type === 'straight') return;
        let path = '';
        if (type === 'bevel') {
const b = (this.S.bevel && this.S.bevel[edgeKey]) ? this.S.bevel[edgeKey] : { dx: 50, dy: 50 };
const clamped = this.clampBevel(b.dx || 50, rect.w, b.dy || 50, rect.h);

          const dx = clamped.dx;
          const dy = clamped.dy;
          if (corner === 'tl')
            path = `M ${rect.x},${rect.y} L ${rect.x+dx},${rect.y} L ${rect.x},${rect.y+dy} Z`;
          else if (corner === 'tr')
            path = `M ${rect.x+rect.w},${rect.y} L ${rect.x+rect.w-dx},${rect.y} L ${rect.x+rect.w},${rect.y+dy} Z`;
          else if (corner === 'br')
            path = `M ${rect.x+rect.w},${rect.y+rect.h} L ${rect.x+rect.w-dx},${rect.y+rect.h} L ${rect.x+rect.w},${rect.y+rect.h-dy} Z`;
          else if (corner === 'bl')
            path = `M ${rect.x+dx},${rect.y+rect.h} L ${rect.x},${rect.y+rect.h} L ${rect.x+dx},${rect.y+rect.h-dy} Z`;
        }
        else if (type === 'notch') {
 const n = (this.S.notch && this.S.notch[edgeKey]) ? this.S.notch[edgeKey] : { dx: 100, dy: 100, offset: 0 };
const clamped = this.clampBevel(n.dx || 100, rect.w, n.dy || 100, rect.h);

          const dx = clamped.dx;
          const dy = clamped.dy;
          if (corner === 'tl')
            path = `M ${rect.x},${rect.y} L ${rect.x+dx},${rect.y} L ${rect.x+dx},${rect.y+dy} L ${rect.x},${rect.y+dy} Z`;
          else if (corner === 'tr')
            path = `M ${rect.x+rect.w},${rect.y} L ${rect.x+rect.w},${rect.y+dy} L ${rect.x+rect.w-dx},${rect.y+dy} L ${rect.x+rect.w-dx},${rect.y} Z`;
          else if (corner === 'br')
            path = `M ${rect.x+rect.w},${rect.y+rect.h} L ${rect.x+rect.w-dx},${rect.y+rect.h} L ${rect.x+rect.w-dx},${rect.y+rect.h-dy} L ${rect.x+rect.w},${rect.y+rect.h-dy} Z`;
          else if (corner === 'bl')
            path = `M ${rect.x},${rect.y+rect.h} L ${rect.x},${rect.y+rect.h-dy} L ${rect.x+dx},${rect.y+rect.h-dy} L ${rect.x+dx},${rect.y+rect.h} Z`;
        }
        else if (type === 'round1' || type === 'semi') {
          let r;
          if (type === 'semi') {
            r = Math.min(rect.h/2, rect.w/2);
          } else {
            r = Math.min(this.S.roundRadius || 30, Math.min(rect.h/2, rect.w/2));
          }
          if (corner === 'tl')
            path = `M ${rect.x},${rect.y+r} A ${r},${r} 0 0 1 ${rect.x+r},${rect.y} L ${rect.x},${rect.y} Z`;
          else if (corner === 'tr')
            path = `M ${rect.x+rect.w-r},${rect.y} A ${r},${r} 0 0 1 ${rect.x+rect.w},${rect.y+r} L ${rect.x+rect.w},${rect.y} Z`;
          else if (corner === 'br')
            path = `M ${rect.x+rect.w},${rect.y+rect.h-r} A ${r},${r} 0 0 1 ${rect.x+rect.w-r},${rect.y+rect.h} L ${rect.x+rect.w},${rect.y+rect.h} Z`;
          else if (corner === 'bl')
            path = `M ${rect.x+r},${rect.y+rect.h} A ${r},${r} 0 0 1 ${rect.x},${rect.y+rect.h-r} L ${rect.x},${rect.y+rect.h} Z`;
        }
        if (path) {
          const overlay = this.SV('path', {
            d: path,
            class: 'edge-overlay',
            'data-edge-key': edgeKey,
            'data-corner': corner
          });
          overlay.addEventListener('click', (e) => {
            e.stopPropagation();
            this.showEdgePopup(rect, corner, edgeKey, e);
          });
          this.svg.appendChild(overlay);
        }
      },
      drawInnerAngleOverlay(x, y, size, isRight, invertVertical = false) {
        const g = this.SV('g', {
          class: 'inner-angle-overlay',
          'data-side': isRight ? 'right' : 'left'
        });
        // 🔥 CALCULER LA TAILLE PROPORTIONNELLE AU VIEWBOX
        const viewBox = this.svg.getAttribute('viewBox').split(' ');
        const viewBoxWidth = parseFloat(viewBox[2]);
        const referenceWidth = 3000; // Largeur de référence
        const baseFontSize = 40; // Taille souhaitée pour la référence
        const fontSize = (viewBoxWidth / referenceWidth) * baseFontSize;
        const lineLength = size * 0.6;
        const arcRadius = size * 0.6;
        if (isRight) {
          const vDir = invertVertical ? -1 : 1;
          const hLine = this.SV('line', {
            x1: x, y1: y,
            x2: x - lineLength, y2: y,
            stroke: '#2c5f2d',
            'stroke-width': '0',
            'stroke-dasharray': '8,6',
            'stroke-linecap': 'round'
          });
          const vLine = this.SV('line', {
            x1: x, y1: y,
            x2: x, y2: y + (lineLength * vDir),
            stroke: '#2c5f2d',
            'stroke-width': 0,
            'stroke-dasharray': '8,6',
            'stroke-linecap': 'round'
          });
          const wedge = this.SV('path', {
            d: invertVertical ?
              `M ${x},${y} L ${x - arcRadius},${y} A ${arcRadius} ${arcRadius} 0 0 1 ${x} ${y - arcRadius} Z` :
              `M ${x},${y} L ${x - arcRadius},${y} A ${arcRadius} ${arcRadius} 0 0 0 ${x} ${y + arcRadius} Z`
          });
          // 🔥 TAILLE DYNAMIQUE CALCULÉE
          const text = this.SV('text', {
            x: x - arcRadius * 0.8 - 120,
            y: invertVertical ? (y - arcRadius * 0.3) : (y + arcRadius * 0.9),
            'font-size': fontSize, // ← TAILLE CALCULÉE
            'font-weight': '800',
            'font-family': 'Arial, sans-serif',
            'fill': '#1a1a1a'
          });
          text.textContent = `${this.S.innerAngle || 90}°`;
          g.appendChild(wedge);
          g.appendChild(hLine);
          g.appendChild(vLine);
          g.appendChild(text);
        } else {
          const vDir = invertVertical ? -1 : 1;
          const hLine = this.SV('line', {
            x1: x, y1: y,
            x2: x + lineLength, y2: y,
            stroke: '#2c5f2d',
            'stroke-width': 0,
            'stroke-dasharray': '8,6',
            'stroke-linecap': 'round'
          });
          const vLine = this.SV('line', {
            x1: x, y1: y,
            x2: x, y2: y + (lineLength * vDir),
            stroke: '#2c5f2d',
            'stroke-width': 0,
            'stroke-dasharray': '8,6',
            'stroke-linecap': 'round'
          });
          const wedge = this.SV('path', {
            d: invertVertical ?
              `M ${x},${y} L ${x + arcRadius},${y} A ${arcRadius} ${arcRadius} 0 0 0 ${x} ${y - arcRadius} Z` :
              `M ${x},${y} L ${x + arcRadius},${y} A ${arcRadius} ${arcRadius} 0 0 1 ${x} ${y + arcRadius} Z`
          });
          // 🔥 TAILLE DYNAMIQUE CALCULÉE
          const text = this.SV('text', {
            x: x + arcRadius * 0.3 + 120,
            y: invertVertical ? (y - arcRadius * 0.3) : (y + arcRadius * 0.9),
            'font-size': fontSize, // ← TAILLE CALCULÉE
            'font-weight': '800',
            'font-family': 'Arial, sans-serif',
            'fill': '#1a1a1a'
          });
          text.textContent = `${this.S.innerAngle || 90}°`;
          g.appendChild(wedge);
          g.appendChild(hLine);
          g.appendChild(vLine);
          g.appendChild(text);
        }
        g.addEventListener('click', (ev) => {
          ev.stopPropagation();
          this.showInnerAnglePopup(ev);
        });
        this.svg.appendChild(g);
      },
      getNotchOffsetLabel(edgeKey) {
        // coins horizontaux haut/bas
        if (edgeKey === 'topLeft' || edgeKey === 'bottomLeft' || edgeKey === 'endHTL' || edgeKey === 'endHBL' || edgeKey === 'footLTL' || edgeKey === 'footLBL') {
          return 'Depuis la gauche';
        }
        if (edgeKey === 'topRight' || edgeKey === 'bottomRight' || edgeKey === 'endHTR' || edgeKey === 'endHBR' || edgeKey === 'footRTR' || edgeKey === 'footRBR') {
          return 'Depuis la droite';
        }
        // montants verticaux gauche
        if (edgeKey === 'endVTL' || edgeKey === 'endVBL' || edgeKey === 'footLTL' || edgeKey === 'footLBL') {
          return 'Depuis le haut';
        }
        // montants verticaux droit
        if (edgeKey === 'endVTR' || edgeKey === 'endVBR' || edgeKey === 'footRTL' || edgeKey === 'footRBL') {
          return 'Depuis le haut';
        }
        // fallback
        return 'Distance';
      },
      showEdgePopup(rect, corner, edgeKey, event) {
        this.closeMenu();
        const type = this.S.edges[edgeKey];
        if (type === 'straight') return;
        this.currentEdgeKey = edgeKey;

        const popup   = this.edgePopup;
        const title   = document.getElementById('edge-popup-title');
        const content = document.getElementById('edge-popup-content');
        if (!popup || !title || !content) return;

        const titles = {
          topLeft:'Coin haut-gauche',topRight:'Coin haut-droit',
          bottomLeft:'Coin bas-gauche',bottomRight:'Coin bas-droit',
          /* lot « messages 2 », N17 à N20 : les noms du dessin (cp-a11y, window.CP_titreCoin, d'abord) ; cette table en repli */
          endHTL:'Coin : plan principal, en haut à gauche',endHTR:'Coin : plan principal, en haut à droite',
          endHBL:'Coin : plan principal, en bas à gauche',endHBR:'Coin : plan principal, en bas à droite',
          endVTL:'Coin : retour, en haut à gauche',endVTR:'Coin : retour, en haut à droite',
          endVBL:'Coin : extrémité du retour, en bas à gauche',endVBR:'Coin : extrémité du retour, en bas à droite',
          footLTL:'Coin : jambe gauche, en haut à gauche',footLBL:'Coin : jambe gauche, en bas à gauche',footLBR:'Coin : jambe gauche, en bas à droite',
          footRTL:'Coin : jambe droite, en haut à gauche',footRTR:'Coin : jambe droite, en haut à droite',footRBL:'Coin : jambe droite, en bas à gauche',footRBR:'Coin : jambe droite, en bas à droite',
          gLeftTL:'Coin : montant gauche, en haut à gauche',gLeftBL:'Coin : montant gauche, en bas à gauche',gLeftBR:'Coin : montant gauche, en bas à droite',
          gTopTL:'Coin : plan du haut, en haut à gauche',gTopTR:'Coin : plan du haut, en haut à droite',gTopBR:'Coin : plan du haut, en bas à droite',
          gRightTL:'Coin : montant droit, en haut à gauche',gRightTR:'Coin : montant droit, en haut à droite',
          gRightBL:'Coin : montant droit, en bas à gauche',gRightBR:'Coin : montant droit, en bas à droite',
          gReturnTL:'Coin : retour, en haut à gauche',gReturnTR:'Coin : retour, en haut à droite',
          gReturnBL:'Coin : retour, en bas à gauche',gReturnBR:'Coin : retour, en bas à droite'
        };

        /* ── En-tête : nom du coin + pastille « Type · +xx€ » ── */
        const ep    = this._eff?.edgePricesEuro || {};
        const euros = Number(ep[type]) || 0;
        const TYPE_LABEL = {
          bevel:'Chanfrein', notch:'Encoche', round1:'Coin arrondi', semi:'Demi-rond'
        };
        title.innerHTML = ((typeof window.CP_titreCoin === 'function' && window.CP_titreCoin(this, edgeKey)) || titles[edgeKey] || 'Dimensions') +
          '<span class="ep-tag">' + (TYPE_LABEL[type] || 'Bord') +
          (euros > 0 ? ' · +' + euros + '€' : '') + '</span>';

        /* ══ BORNES RÉELLES ══
           rect.w et rect.h sont les dimensions de la pièce à ce coin, dans
           la même unité que les paramètres (mm) — c'est déjà ce que lit
           clampBevel() ailleurs. Aucune découpe ne peut dépasser la pièce :
           on conserve MIN_REST mm de matière, sinon elle la traverse. */
        const MIN_REST = 30;
        const pieceW = Math.max(80, Math.round(Number(rect && rect.w) || 600));
        const pieceH = Math.max(80, Math.round(Number(rect && rect.h) || 600));

        /* Un seul descripteur par type : tout le reste du code est commun. */
        const SPEC = {
          notch:  { min:30, idA:'edge-nx', idB:'edge-ny', labA:'Longueur',   labB:'Profondeur' },
          bevel:  { min:10, idA:'edge-bx', idB:'edge-by', labA:'Horizontal', labB:'Vertical'   },
          round1: { min:10, idA:'edge-r',  idB:null,      labA:'Rayon',      labB:null         },
          semi:   { min:0,  idA:null,      idB:null,      labA:null,         labB:null         }
        };
        const spec  = SPEC[type] || SPEC.notch;
        const MIN_V = spec.min;

        /* Rayon : borné par 200 mm ET par la moitié de la plus petite cote,
           sinon l'arc dépasse la pièce. */
        const maxR  = Math.max(MIN_V, Math.min(200, Math.floor(Math.min(pieceW, pieceH) / 2)));
        const maxA  = (type === 'round1') ? maxR : Math.max(MIN_V, pieceW - MIN_REST);
        const maxB  = Math.max(MIN_V, pieceH - MIN_REST);
        const fit   = (v, mx) => Math.min(Math.max(Math.round(Number(v) || 0) || MIN_V, MIN_V), mx);

        /* Valeurs courantes, ramenées dans les bornes AVANT tout affichage
           (le plan a pu être redimensionné depuis la dernière saisie). */
        let valA, valB;
        if (type === 'notch') {
          if (!this.S.notch[edgeKey]) this.S.notch[edgeKey] = { dx:100, dy:100, offset:0 };
          valA = this.S.notch[edgeKey].dx = fit(this.S.notch[edgeKey].dx, maxA);
          valB = this.S.notch[edgeKey].dy = fit(this.S.notch[edgeKey].dy, maxB);
        } else if (type === 'bevel') {
          if (!this.S.bevel[edgeKey]) this.S.bevel[edgeKey] = { dx:50, dy:50 };
          valA = this.S.bevel[edgeKey].dx = fit(this.S.bevel[edgeKey].dx, maxA);
          valB = this.S.bevel[edgeKey].dy = fit(this.S.bevel[edgeKey].dy, maxB);
        } else if (type === 'round1') {
          valA = valB = this.S.roundRadius = fit(this.S.roundRadius || 30, maxR);
        } else {
          /* Demi-rond : rayon imposé, identique à celui de drawEdgeOverlay. */
          valA = valB = Math.round(Math.min(pieceW, pieceH) / 2);
        }

        const top  = (corner === 'tr' || corner === 'tl');
        const left = (corner === 'tl' || corner === 'bl');
        const isRadius = (type === 'round1' || type === 'semi');

        /* ═══════════ FIGURE ═══════════ */
        const schema = (av, bv) => {
          /* Le demi-rond n'est pas borné par les 200 mm du coin arrondi :
             son rayon est imposé par la pièce, on le prend tel quel. */
          const a = (type === 'semi') ? valA
                  : isRadius          ? fit(av, maxR)
                                      : fit(av, maxA);
          const b = isRadius ? a : fit(bv, maxB);

          /* Le panneau est tracé à ses VRAIES proportions : il occupe au
             mieux BOXW × BOXH sans se déformer. Le facteur d'échelle étant
             le même dans les deux directions, la découpe tracée avec ce
             facteur est juste par rapport à elle-même ET par rapport à la
             pièce — une entaille de 100 sur un plan de 2400 se voit petite,
             parce qu'elle l'est. */
          const BOXW = 196, BOXH = 110;
          const CX = 150 + (left ? 7 : -7);
          const CY = 98  + (top  ? 7 : -7);
          const s  = Math.min(BOXW / pieceW, BOXH / pieceH);
          const pw = pieceW * s, ph = pieceH * s;
          const X0 = CX - pw / 2, X1 = CX + pw / 2;
          const Y0 = CY - ph / 2, Y1 = CY + ph / 2;

          /* Seule entorse à l'échelle : sur un plan très long une petite
             découpe tomberait sous le pixel. On relève alors le facteur
             pour LE DESSIN DE LA DÉCOUPE seulement, sans jamais dépasser
             92 % de la pièce — et toujours un facteur unique, donc le
             rapport entre les deux cotes reste exact. */
          /* Demi-rond : le rayon vaut la moitié de la plus petite cote, il
             occupe donc exactement 50 % ; coin arrondi : plafonné à 45 %
             pour que le quart de cercle reste un coin. */
          const CAPR = (type === 'semi') ? 0.5 : 0.45;
          const sN = isRadius
            /* Un rayon a besoin d'un arc lisible : plancher plus haut, et
               plafond à 45 % de la plus petite cote pour que le quart de
               cercle reste un coin et non une pièce ronde. */
            ? Math.min(Math.max(s, 11 / a),
                Math.min(CAPR * pw / a, CAPR * ph / a))
            : Math.min(
                Math.max(s, 4 / Math.min(a, b)),
                Math.min(0.92 * pw / a, 0.92 * ph / b)
              );
          const wn = sN * a, hn = sN * b;
          const r  = Math.min(wn, hn);

          const nx0 = left ? X0 : X1 - wn;
          const nx1 = left ? X0 + wn : X1;
          const ny0 = top  ? Y0 : Y1 - hn;
          const ny1 = top  ? Y0 + hn : Y1;

          /* Contour de la pièce APRÈS usinage. Le coin est remplacé par un
             segment différent selon le type, le reste du tracé est commun. */
          const cut = (fromX, fromY, toX, toY) => {
            if (type === 'notch')  return ' V ' + toY + ' H ' + toX + ' ';
            if (type === 'bevel')  return ' L ' + toX + ',' + toY + ' ';
            return ' A ' + r + ',' + r + ' 0 0 1 ' + toX + ',' + toY + ' ';
          };
          const cutV = (fromX, fromY, toX, toY) => {
            /* variante où l'on part d'un bord vertical (coins tl et bl) */
            if (type === 'notch')  return ' H ' + toX + ' V ' + toY + ' ';
            if (type === 'bevel')  return ' L ' + toX + ',' + toY + ' ';
            return ' A ' + r + ',' + r + ' 0 0 1 ' + toX + ',' + toY + ' ';
          };

          const aX = left ? X0 + (isRadius ? r : wn) : X1 - (isRadius ? r : wn);
          const aY = top  ? Y0 + (isRadius ? r : hn) : Y1 - (isRadius ? r : hn);

          let d;
          if (corner === 'tr') {
            d = 'M ' + X0 + ',' + Y0 + ' H ' + aX + cut(aX, Y0, X1, aY) + 'V ' + Y1 + ' H ' + X0 + ' Z';
          } else if (corner === 'br') {
            d = 'M ' + X0 + ',' + Y0 + ' H ' + X1 + ' V ' + aY + cut(X1, aY, aX, Y1) + 'H ' + X0 + ' Z';
          } else if (corner === 'bl') {
            d = 'M ' + X0 + ',' + Y0 + ' H ' + X1 + ' V ' + Y1 + ' H ' + aX + cutV(aX, Y1, X0, aY) + 'Z';
          } else {
            d = 'M ' + aX + ',' + Y0 + ' H ' + X1 + ' V ' + Y1 + ' H ' + X0 + ' V ' + aY +
                cutV(X0, aY, aX, Y0) + 'Z';
          }

          /* ── Cotes ── */
          let dims = '';
          if (isRadius) {
            /* Un rayon ne se cote pas avec deux flèches : on souligne l'arc
               lui-même et on l'annote par une ligne d'attache, comme sur un
               plan. Longueur d'attache FIXE (22 unités), indépendante du
               rayon : sur un petit rayon une flèche à l'échelle serait plus
               courte que sa propre pointe. */
            const cxA = left ? X0 + r : X1 - r;
            const cyA = top  ? Y0 + r : Y1 - r;
            const ux  = left ? -0.7071 : 0.7071;
            const uy  = top  ? -0.7071 : 0.7071;
            const ax0 = left ? X0 : X1 - r, ay0 = top ? Y0 + r : Y1 - r;
            const ax1 = left ? X0 + r : X1, ay1 = top ? Y0 : Y1;
            /* Le sens de parcours de l'arc diffère selon le coin : on repart
               des mêmes extrémités que le contour pour rester superposé. */
            const arcD = (corner === 'tr')
              ? 'M ' + (X1 - r) + ',' + Y0 + ' A ' + r + ',' + r + ' 0 0 1 ' + X1 + ',' + (Y0 + r)
              : (corner === 'br')
              ? 'M ' + X1 + ',' + (Y1 - r) + ' A ' + r + ',' + r + ' 0 0 1 ' + (X1 - r) + ',' + Y1
              : (corner === 'bl')
              ? 'M ' + (X0 + r) + ',' + Y1 + ' A ' + r + ',' + r + ' 0 0 1 ' + X0 + ',' + (Y1 - r)
              : 'M ' + X0 + ',' + (Y0 + r) + ' A ' + r + ',' + r + ' 0 0 1 ' + (X0 + r) + ',' + Y0;
            const px = cxA + r * ux,        py = cyA + r * uy;
            const lx = cxA + (r + 22) * ux, ly = cyA + (r + 22) * uy;
            dims =
              '<path class="ns-arc" d="' + arcD + '"/>' +
              '<line class="ns-dim" x1="' + lx + '" y1="' + ly + '" x2="' + px + '" y2="' + py +
                   '" marker-end="url(#ns-a)"/>' +
              '<text class="ns-txt" x="' + (lx + 8 * ux) + '" y="' + (ly + 8 * uy + 4) +
                   '" text-anchor="middle">R ' + a + ' mm</text>';
          } else {
            /* Cote courte : deux têtes de flèche de 6 unités dans un trait
               de 8 se chevauchent et forment un nœud illisible. On bascule
               alors sur la convention du dessin technique — flèches posées
               À L'EXTÉRIEUR, pointant vers la cote. Seuil : 18 unités. */
            const SHORT = 18;
            const arrow = (x1, y1, x2, y2, len) => (len >= SHORT)
              ? '<line class="ns-dim" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 +
                '" marker-start="url(#ns-b)" marker-end="url(#ns-a)"/>'
              : '<line class="ns-dim" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>' +
                '<line class="ns-dim" x1="' + (x1 === x2 ? x1 : x1 - 13) + '" y1="' + (y1 === y2 ? y1 : y1 - 13) +
                '" x2="' + x1 + '" y2="' + y1 + '" marker-end="url(#ns-a)"/>' +
                '<line class="ns-dim" x1="' + (x1 === x2 ? x2 : x2 + 13) + '" y1="' + (y1 === y2 ? y2 : y2 + 13) +
                '" x2="' + x2 + '" y2="' + y2 + '" marker-end="url(#ns-a)"/>';

            const dimY = top  ? Y0 - 17 : Y1 + 17;
            const dimX = left ? X0 - 17 : X1 + 17;
            const txtY = top  ? dimY - 8 : dimY + 15;
            const txtX = left ? dimX - 12 : dimX + 12;
            const midX = (nx0 + nx1) / 2;
            const midY = (ny0 + ny1) / 2;

            dims =
              '<line class="ns-rap" x1="' + nx0 + '" y1="' + dimY + '" x2="' + nx0 + '" y2="' + ny0 + '"/>' +
              '<line class="ns-rap" x1="' + nx1 + '" y1="' + dimY + '" x2="' + nx1 + '" y2="' + ny1 + '"/>' +
              arrow(nx0, dimY, nx1, dimY, nx1 - nx0) +
              '<text class="ns-txt" x="' + midX + '" y="' + txtY + '" text-anchor="middle">' + a + ' mm</text>' +
              '<line class="ns-rap" x1="' + dimX + '" y1="' + ny0 + '" x2="' + nx0 + '" y2="' + ny0 + '"/>' +
              '<line class="ns-rap" x1="' + dimX + '" y1="' + ny1 + '" x2="' + nx1 + '" y2="' + ny1 + '"/>' +
              arrow(dimX, ny0, dimX, ny1, ny1 - ny0) +
              '<text class="ns-txt" x="' + txtX + '" y="' + midY + '" text-anchor="middle" ' +
                   'transform="rotate(-90 ' + txtX + ' ' + midY + ')">' + b + ' mm</text>';
          }

          return '' +
            '<svg class="edge-schema" viewBox="0 0 300 196" role="img" ' +
                 'aria-label="' + (TYPE_LABEL[type] || 'Bord') + ' de ' + a +
                 ' mm sur une pièce de ' + pieceW + ' sur ' + pieceH + ' mm">' +
              '<defs>' +
                '<marker id="ns-a" markerWidth="6" markerHeight="6" refX="5.2" refY="3" orient="auto">' +
                  '<path d="M0,0.4 L6,3 L0,5.6 z" fill="#b07c35"/></marker>' +
                '<marker id="ns-b" markerWidth="6" markerHeight="6" refX="0.8" refY="3" orient="auto">' +
                  '<path d="M6,0.4 L0,3 L6,5.6 z" fill="#b07c35"/></marker>' +
              '</defs>' +
              /* pièce d'origine en pointillé : la découpe est la différence
                 entre ce fantôme et la pièce pleine */
              '<rect class="ns-ghost" x="' + X0 + '" y="' + Y0 + '" width="' + pw +
                   '" height="' + ph + '" rx="2"/>' +
              '<path class="ns-piece" d="' + d + '"/>' +
              dims +
            '</svg>';
        };

        /* ═══════════ MARKUP ═══════════ */
        const field = (id, val, min, max, hintId) =>
          '<div class="ni-field">' +
            '<button type="button" class="ni-step" data-for="' + id + '" data-step="-1" aria-label="Diminuer">−</button>' +
            '<input type="number" id="' + id + '" value="' + val + '" min="' + min + '" max="' + max +
                  '" step="1" inputmode="numeric">' +
            '<span>mm</span>' +
            '<button type="button" class="ni-step" data-for="' + id + '" data-step="1" aria-label="Augmenter">+</button>' +
          '</div>';

        let inputsHtml = '';
        if (type === 'semi') {
          inputsHtml = '<div class="edge-auto">Rayon imposé : <b>' + valA +
                       ' mm</b><small>moitié de la plus petite cote de la pièce</small></div>';
        } else if (isRadius) {
          inputsHtml = '<div class="edge-inputs is-single">' +
                         '<label for="' + spec.idA + '">' + spec.labA + '</label>' +
                         field(spec.idA, valA, MIN_V, maxA) +
                         '<small class="ni-hint" id="ni-hint-a">' + MIN_V + ' à ' + maxA + ' mm</small>' +
                       '</div>';
        } else {
          inputsHtml = '<div class="edge-inputs">' +
                         '<label for="' + spec.idA + '">' + spec.labA + '</label>' +
                         '<label for="' + spec.idB + '">' + spec.labB + '</label>' +
                         field(spec.idA, valA, MIN_V, maxA) +
                         field(spec.idB, valB, MIN_V, maxB) +
                         '<small class="ni-hint" id="ni-hint-a">' + MIN_V + ' à ' + maxA + ' mm</small>' +
                         '<small class="ni-hint" id="ni-hint-b">' + MIN_V + ' à ' + maxB + ' mm</small>' +
                       '</div>';
        }

        content.innerHTML =
          '<div class="edge-fig">' +
            '<div id="edge-schema-host">' + schema(valA, valB) + '</div>' +
            /* Rappel des dimensions du plan : en HTML sous la figure et non
               dans le SVG, où il heurtait la cote basse sur un coin bas. */
            '<div class="edge-piece">Pièce ' + pieceW + ' × ' + pieceH + ' mm</div>' +
          '</div>' +
          inputsHtml +
          '<div class="edge-actions' + (type === 'semi' ? ' is-single' : '') + '">' +
            '<button type="button" id="edge-delete">Supprimer</button>' +
            (type === 'semi' ? '' : '<button type="button" id="edge-apply">Appliquer</button>') +
          '</div>';

        /* ═══════════ CÂBLAGE ═══════════ */
        const host  = document.getElementById('edge-schema-host');
        const inA   = spec.idA ? document.getElementById(spec.idA) : null;
        const inB   = spec.idB ? document.getElementById(spec.idB) : null;
        const hintA = document.getElementById('ni-hint-a');
        const hintB = document.getElementById('ni-hint-b');

        const redraw = () => {
          if (host) host.innerHTML = schema(inA ? inA.value : valA, inB ? inB.value : valB);
        };

        /* SAISIE MANUELLE — le champ reste libre, les curseurs ne sont
           qu'un complément. Pendant la frappe on n'écrase JAMAIS la valeur
           en cours : taper « 450 » passe par « 4 » puis « 45 ». On se
           contente de signaler, et seulement le dépassement du maximum ;
           le minimum n'est contrôlé qu'à la sortie du champ, sinon le
           champ virerait au rouge dès le premier chiffre. */
        const flag = (el, hint, max, live) => {
          if (!el || !hint) return;
          const v = parseInt(el.value, 10);
          const tooBig = Number.isFinite(v) && v > max;
          const bad = live ? tooBig : (!Number.isFinite(v) || v < MIN_V || v > max);
          if (el.parentNode) el.parentNode.classList.toggle('is-error', bad);
          hint.classList.toggle('is-error', bad);
          hint.textContent = !bad ? (MIN_V + ' à ' + max + ' mm')
                           : tooBig ? ('maximum ' + max + ' mm')
                                    : ('minimum ' + MIN_V + ' mm');
        };

        const settle = () => {
          if (inA) inA.value = String(fit(inA.value, maxA));
          if (inB) inB.value = String(fit(inB.value, maxB));
          flag(inA, hintA, maxA, false);
          flag(inB, hintB, maxB, false);
          redraw();
        };

        [[inA, hintA, maxA], [inB, hintB, maxB]].forEach(([el, hint, max]) => {
          if (!el) return;
          el.addEventListener('input',  function () { flag(el, hint, max, true); redraw(); });
          el.addEventListener('change', settle);
          el.addEventListener('blur',   settle);
          /* Un clic dans le champ sélectionne la valeur : on remplace en
             tapant, sans avoir à effacer d'abord. */
          el.addEventListener('focus',  function () { el.select(); });
        });

        /* ══ CURSEURS − / + ══
           Clic simple : un pas de 1 mm. Maintien : rien pendant 350 ms —
           un clic normal ne déclenche jamais la répétition — puis un pas
           toutes les 90 ms, accéléré à 35 ms au bout d'une seconde. C'est
           la CADENCE qui augmente, jamais l'incrément : aucune valeur
           n'est sautée. */
        let holdT = null, holdI = null;
        const stopHold = () => {
          if (holdT) { clearTimeout(holdT);  holdT = null; }
          if (holdI) { clearInterval(holdI); holdI = null; }
        };

        content.querySelectorAll('.ni-step').forEach(btn => {
          const isA  = (btn.dataset.for === spec.idA);
          const el   = isA ? inA : inB;
          const hint = isA ? hintA : hintB;
          const max  = isA ? maxA : maxB;
          const dir  = parseInt(btn.dataset.step, 10) || 1;
          if (!el) return;

          const tick = () => {
            const base = parseInt(el.value, 10);
            el.value = String(fit((Number.isFinite(base) ? base : MIN_V) + dir, max));
            flag(el, hint, max, false);
            redraw();
          };

          btn.addEventListener('pointerdown', (ev) => {
            ev.preventDefault();          /* garde le focus dans le champ */
            stopHold();
            tick();
            holdT = setTimeout(() => {
              holdI = setInterval(tick, 90);
              setTimeout(() => {
                if (!holdI) return;
                clearInterval(holdI);
                holdI = setInterval(tick, 35);
              }, 1000);
            }, 350);
          });
          ['pointerup', 'pointerleave', 'pointercancel'].forEach(e =>
            btn.addEventListener(e, stopHold));
        });
        /* Relâchement hors du bouton : sans ça la répétition ne s'arrête
           jamais si le doigt glisse avant de lever. */
        /* FUITE D'ÉCOUTEURS — showEdgePopup() est rappelée à CHAQUE clic sur
           un bord. Sans ce retrait, chaque ouverture ajoutait deux écouteurs
           window supplémentaires, qui restaient accrochés à des popups déjà
           remplacées. On mémorise donc la fonction sur l'instance pour
           pouvoir retirer celle du tour précédent. */
        if (this._edgeStopHold) {
          window.removeEventListener('pointerup', this._edgeStopHold);
          window.removeEventListener('blur',      this._edgeStopHold);
        }
        this._edgeStopHold = stopHold;
        window.addEventListener('pointerup', stopHold);
        window.addEventListener('blur',      stopHold);

        /* ═══════════ POSITIONNEMENT ✎ RÉV.20 ═══════════
           La popup est en position:FIXED : on la cale sur le VIEWPORT et
           non sur #stage. Le stage est en overflow:hidden et peut être
           moins haut que la popup ; dans ce cas aucun placement relatif
           au stage n'est valide et la popup sortait tronquée en bas.

           transform:'none' d'abord — showDepthSelector() laisse un
           translate(-50%,-50%) sur la MÊME popup. On retire .hidden AVANT
           de mesurer : une boîte en display:none a un offsetWidth de 0. */
        popup.style.transform = 'none';
        popup.classList.remove('hidden');

        const M  = 10;
        const cx = (event && Number.isFinite(event.clientX)) ? event.clientX : document.documentElement.clientWidth / 2;
        const cy = (event && Number.isFinite(event.clientY)) ? event.clientY : document.documentElement.clientHeight / 2;

        const place = () => {
          if (popup.classList.contains('hidden')) return;
          const vw  = document.documentElement.clientWidth;
          const vh  = document.documentElement.clientHeight;
          const pw2 = popup.offsetWidth  || 300;
          const ph2 = popup.offsetHeight || 240;

          let px = cx + M;
          let py = cy + M;
          /* Pas de place à droite / en bas : on bascule du côté opposé du
             clic plutôt que de coller la popup au bord. */
          if (px + pw2 > vw - M) px = cx - pw2 - M;
          if (py + ph2 > vh - M) py = cy - ph2 - M;

          /* Bornage en coordonnées VIEWPORT. */
          px = Math.max(M, Math.min(px, vw - pw2 - M));
          py = Math.max(M, Math.min(py, vh - ph2 - M));

          /* Un position:fixed s'ancre au viewport SAUF si un ancêtre porte
             un transform / filter / will-change : cet ancêtre devient alors
             le bloc conteneur. On mesure donc le bloc conteneur RÉEL au
             lieu de le supposer, et on soustrait son origine. */
          const host = popup.offsetParent;
          const hr   = host ? host.getBoundingClientRect() : null;
          popup.style.left = (px - (hr ? hr.left : 0)) + 'px';
          popup.style.top  = (py - (hr ? hr.top  : 0)) + 'px';
        };

        /* Trois passes. La première mesure une popup dont la police n'est
           pas encore chargée : sa hauteur augmente ensuite de quelques
           pixels et le bornage devient faux. Les deux repasses recalent
           sur la hauteur définitive. Coût nul, aucun clignotement. */
        place();
        requestAnimationFrame(place);
        setTimeout(place, 160);

        /* ═══════════ ACTIONS ═══════════ */
        const applyBtn = document.getElementById('edge-apply');
        if (applyBtn) {
          applyBtn.addEventListener('click', () => {
            settle();                       /* borne avant d'enregistrer */
            const a = inA ? parseInt(inA.value, 10) : 0;
            const b = inB ? parseInt(inB.value, 10) : 0;
            if (type === 'bevel') {
              this.S.bevel[edgeKey].dx = a;
              this.S.bevel[edgeKey].dy = b;
            } else if (type === 'notch') {
              this.S.notch[edgeKey].dx = a;
              this.S.notch[edgeKey].dy = b;
              this.S.notch[edgeKey].offset = 0;
            } else if (type === 'round1') {
              this.S.roundRadius = a;
            }
            stopHold();
            this.closeEdgePopup();
            this.render();
          });
        }

        const deleteBtn = document.getElementById('edge-delete');
        if (deleteBtn) {
          deleteBtn.addEventListener('click', () => {
            stopHold();
            this.clearEdgeType(edgeKey);
            this.closeEdgePopup();
            this.render();
          });
        }
      },
    closeEdgePopup() {
  if (this.edgePopup) this.edgePopup.classList.add('hidden');
  this.currentEdgeKey = null;
},

      showInnerAnglePopup(event) {
        this.closeMenu();
        const popup = this.edgePopup;
        const titleEl = document.getElementById('edge-popup-title');
        const content = document.getElementById('edge-popup-content');
        if (!popup || !titleEl || !content) return;
        titleEl.textContent = 'Angle intérieur';
        const current = this.S.innerAngle || 90;
        const epAngle = this._eff?.edgePricesEuro || {};
        const eurosAngle = Number(epAngle.innerAngle) || 0;
        const anglePriceTag = (eurosAngle > 0 && current !== 90) ? `<small class="em-price">+${eurosAngle}€</small>` : '';
        content.innerHTML = `
          <div class="input-group"><label>∠</label>
            <input type="number" id="inner-angle-input" value="${current}" min="80" max="100">
            <span>° (85 – 95)</span></div>
          ${anglePriceTag}
          <button id="edge-apply">Appliquer</button>`;
        /* ═══ POSITIONNEMENT — RÉV.20 : ancré au VIEWPORT ═══
           Même raisonnement que showEdgePopup() : la popup est en
           position:fixed, ses coordonnées sont celles de l'écran. On mesure
           la popup RÉELLE au lieu des 260 x 220 codés en dur, et on retire
           .hidden AVANT de mesurer (display:none => offsetWidth de 0).
           transform:'none' annule le translate(-50%,-50%) que
           showDepthSelector() laisse sur ce MÊME élément. */
        popup.style.transform = 'none';
        popup.classList.remove('hidden');

        const MA  = 10;
        const _ax = (event && Number.isFinite(event.clientX)) ? event.clientX : document.documentElement.clientWidth  / 2;
        const _ay = (event && Number.isFinite(event.clientY)) ? event.clientY : document.documentElement.clientHeight / 2;

        const placeAngle = () => {
          if (popup.classList.contains('hidden')) return;
          const vw = document.documentElement.clientWidth;
          const vh = document.documentElement.clientHeight;
          const pw = popup.offsetWidth  || 300;
          const ph = popup.offsetHeight || 240;

          let px = _ax + MA;
          let py = _ay + MA;
          if (px + pw > vw - MA) px = _ax - pw - MA;
          if (py + ph > vh - MA) py = _ay - ph - MA;

          px = Math.max(MA, Math.min(px, vw - pw - MA));
          py = Math.max(MA, Math.min(py, vh - ph - MA));

          /* Un position:fixed s'ancre au viewport SAUF si un ancetre porte un
             transform : cet ancetre devient le bloc conteneur. On mesure donc
             le bloc conteneur REEL et on soustrait son origine. */
          const host = popup.offsetParent;
          const hr   = host ? host.getBoundingClientRect() : null;
          popup.style.left = (px - (hr ? hr.left : 0)) + 'px';
          popup.style.top  = (py - (hr ? hr.top  : 0)) + 'px';
        };

        placeAngle();
        requestAnimationFrame(placeAngle);
        setTimeout(placeAngle, 160);
        const input = document.getElementById('inner-angle-input');
        const applyBt = document.getElementById('edge-apply');
        if (applyBt && input) {
          applyBt.addEventListener('click', () => {
            const raw = parseFloat(input.value);
            if (!isNaN(raw)) {
              // on borne entre 85° et 95° comme tu voulais
              const clamped = Math.max(85, Math.min(95, raw));
              this.S.innerAngle = clamped;
            }
            this.closeEdgePopup();
            this.render();
          });
        }
      },

      clearAutoBandingFromEdge(edgeKey) {
  // supprime les chants auto-activés PAR CE edgeKey
  this.S.edgeBanding = this.S.edgeBanding || {};
  this.S.edgeBandingByEdge = this.S.edgeBandingByEdge || {};

  const eKey = String(edgeKey || '');
  const links = this.S.edgeBandingByEdge[eKey];
  if (!links) return;

  Object.keys(links).forEach((bandingKey) => {
    // ✅ on décoche réellement
    this.S.edgeBanding[bandingKey] = false;

    // si tu préfères revenir au défaut plutôt que false :
    // delete this.S.edgeBanding[bandingKey];
  });

  delete this.S.edgeBandingByEdge[eKey];
},

clearEdgeType(edgeKey) {
  // remet le bord en droit + nettoie bevel/notch + décoche chants auto-liés
  if (!edgeKey) return;

  this.S.edges = this.S.edges || {};
  const prev = this.S.edges[edgeKey] || 'straight';

  // 1) repasse en droit
  this.S.edges[edgeKey] = 'straight';

  // 2) nettoyage paramètres
  if (this.S.bevel?.[edgeKey]) delete this.S.bevel[edgeKey];
  if (this.S.notch?.[edgeKey]) delete this.S.notch[edgeKey];

  // 3) ✅ si avant c’était un bord spécial -> on enlève les chants auto-cochés
  if (prev !== 'straight') {
    this.clearAutoBandingFromEdge(edgeKey);
  }
},


      showDepthSelector(currentValue, onCommit) {
  this.closeMenu();
  const popup = this.edgePopup;
  const titleEl = document.getElementById('edge-popup-title');
  const content = document.getElementById('edge-popup-content');
  
  if (!popup || !titleEl || !content) return;
  
  titleEl.textContent = 'Choisir une profondeur';
  
  // Récupérer les profondeurs disponibles
  const config = window.CONFIGURATOR_CONFIG || {};
  let standards = config.depthStandards || [];
  let customs = config.depthCustomRanges || [];
  
  // Filtrer selon la règle de collection
  const depthRule = this._eff?.depthRule;
  if (depthRule?.enabled && Array.isArray(depthRule.allowed) && depthRule.allowed.length) {
    const allowedSet = new Set(depthRule.allowed);
    standards = standards.filter(d => allowedSet.has(d.id));
    customs = customs.filter(d => allowedSet.has(d.id));
  }
  
  // Fallback si aucune profondeur définie
  if (!standards.length && !customs.length) {
    standards = [
      { id: 'depth_600', depth_mm: 600, label: '600 mm', extraPrice: 0 }
    ];
  }
  
  let html = '<div class="depth-selector-grid">';
  
  const isCustomMode = (this.S.depthMode === 'custom');

  // Profondeurs standards
  standards.forEach(depth => {
    const isSelected = !isCustomMode && (currentValue === depth.depth_mm);
    const priceLabel = depth.extraPrice > 0 ? `+${depth.extraPrice}€` : '';
html += `
  <button class="depth-btn ${isSelected ? 'selected' : ''}" data-type="standard" data-value="${depth.depth_mm}" data-price="${depth.extraPrice}">
    <span class="depth-label">${depth.label}</span>
    <small class="depth-id">${depth.id}</small>
    ${priceLabel ? `<small class="depth-price">${priceLabel}</small>` : ''}
  </button>
`;

  });
  
  // Profondeurs sur-mesure
customs.forEach((range, idx) => {
  const priceLabel = range.extraPrice > 0 ? `+${range.extraPrice}€` : '';
  const isInRange = isCustomMode && (currentValue >= range.min_mm && currentValue <= range.max_mm);

html += `
  <button class="depth-btn depth-btn-custom ${isInRange ? 'selected' : ''}" data-type="custom" data-idx="${idx}" data-price="${range.extraPrice}">
    <span class="depth-label">${range.label}</span>
    <small class="depth-id">${range.id}</small>
    <small class="depth-range">${range.min_mm}–${range.max_mm} mm</small>
    ${priceLabel ? `<small class="depth-price">${priceLabel}</small>` : ''}
  </button>
`;
  
});
  
  html += '</div>';
  
  // Zone de saisie personnalisée (cachée par défaut)
  html += `
    <div class="depth-custom-input hidden" id="depth-custom-input-zone">
      <div class="input-group">
        <label>Profondeur (mm):</label>
        <input type="number" id="depth-custom-value" value="${currentValue}" min="300" max="900">
        <span>mm</span>
      </div>
      <div class="depth-range-info" id="depth-range-info"></div>
    </div>
  `;
  
  html += '<button id="depth-apply" class="btn-primary">Valider</button>';
  
  content.innerHTML = html;
  
  // Événements
  const applyBtn = document.getElementById('depth-apply');
  const customInputZone = document.getElementById('depth-custom-input-zone');
  const customInput = document.getElementById('depth-custom-value');
  const rangeInfo = document.getElementById('depth-range-info');
  
  let selectedType = 'standard';
  let selectedValue = currentValue;
  let selectedCustomIdx = null;
  
  content.querySelectorAll('.depth-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    // UI sélection
    content.querySelectorAll('.depth-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');

    selectedType = btn.dataset.type;

    // =========================
    // STANDARD
    // =========================
    if (selectedType === 'standard') {
      selectedCustomIdx = null;
      selectedValue = parseInt(btn.dataset.value, 10) || currentValue;

      customInputZone.classList.add('hidden');

      // ✅ FORCE MODE STANDARD + ID + P
      const standard = standards.find(d => Number(d.depth_mm) === Number(selectedValue));
      this.S.depthMode = 'standard';
      this.S.depthSelectedId = standard ? standard.id : null;
      this.S.P = Number(selectedValue);

      return;
    }

    // =========================
    // SUR-MESURE
    // =========================
    selectedCustomIdx = parseInt(btn.dataset.idx, 10);
    const range = customs[selectedCustomIdx];
    if (!range) return;

    customInputZone.classList.remove('hidden');
    customInput.min = range.min_mm;
    customInput.max = range.max_mm;

    // valeur par défaut dans la plage
    const v0 =
      (currentValue >= range.min_mm && currentValue <= range.max_mm)
        ? currentValue
        : range.min_mm;

    customInput.value = String(v0);
    rangeInfo.textContent = `Min: ${range.min_mm}mm - Max: ${range.max_mm}mm`;
    selectedValue = parseInt(customInput.value, 10) || range.min_mm;

    // ✅ MODE CUSTOM + ID + P (valeur actuelle de l'input)
    this.S.depthMode = 'custom';
    this.S.depthSelectedId = range.id;
    this.S.P = Number(selectedValue);
  });
});

// Mise à jour en temps réel de la valeur sur-mesure
if (customInput) {
  customInput.addEventListener('input', () => {
    const v = parseInt(customInput.value, 10);
    selectedValue = Number.isFinite(v) ? v : (parseInt(customInput.min, 10) || 300);

    // ✅ si on est en custom, on garde le state synchro
    if (selectedType === 'custom') {
      const range = customs[selectedCustomIdx];
      if (range) {
        this.S.depthMode = 'custom';
        this.S.depthSelectedId = range.id;
        this.S.P = Number(selectedValue);
      }
    }
  });
}

if (applyBtn) {
  applyBtn.addEventListener('click', () => {
    // ✅ Validation + synchro state AVANT commit
    if (selectedType === 'standard') {
      const standard = standards.find(d => Number(d.depth_mm) === Number(selectedValue));

      this.S.depthMode = 'standard';
      this.S.depthSelectedId = standard ? standard.id : null;
      // (optionnel) si tu veux aussi forcer P ici :
      this.S.P = Number(selectedValue);
    } else {
      const range = customs[selectedCustomIdx];
      if (!range) return;

      const val = parseInt(customInput.value, 10);
      if (!Number.isFinite(val) || val < range.min_mm || val > range.max_mm) {
        alert(`La profondeur doit être entre ${range.min_mm} et ${range.max_mm} mm`);
        return;
      }

      selectedValue = val;

      this.S.depthMode = 'custom';
      this.S.depthSelectedId = range.id;
      // (optionnel) si tu veux aussi forcer P ici :
      this.S.P = Number(selectedValue);
    }

    // ✅ commit (mettra aussi P1/P2/Pl/... si ton onCommit le fait)
    if (onCommit && selectedValue > 0) {
      onCommit(selectedValue);
    }

    this.closeEdgePopup();
    this.render();
  });
}

// Positionner la popup
popup.style.left = '50%';
popup.style.top = '50%';
popup.style.transform = 'translate(-50%, -50%)';
popup.classList.remove('hidden');
},


hasSelectableEdgeTypes() {
  const et = this._eff?.edgeTypes;

  // si pas de règles => on laisse (comportement actuel)
  if (!et) return true;

  // si aucune option autre que "straight" n'est dispo => pas de hits
  return ['round1', 'semi', 'bevel', 'notch'].some(k => et[k] === true);
},

addHit(x, y, w, h, id, rect = null, corner = null) {
  // ✅ Si seuls les bords "droit" sont autorisés, on n'affiche pas les zones cliquables
  if (!this.hasSelectableEdgeTypes()) return;

  console.log(`[addHit] Création zone: ${id} à (${x},${y}) taille ${w}x${h}`);
  const g=this.SV('g',{}),
        hl=this.SV('rect',{x,y,width:w,height:h,class:'hl','pointer-events':'none'}),
        r=this.SV('rect',{x,y,width:w,height:h,class:'hit',fill:'transparent','pointer-events':'all'});
        g.appendChild(r);
        g.appendChild(hl);
        r.addEventListener('click', ev => {
          console.log(`[addHit] CLICK sur ${id}`);
          console.log(`[addHit] TOUS LES EDGES:`, JSON.stringify(this.S.edges));
          console.log(`[addHit] rect=`, rect);
          console.log(`[addHit] corner=`, corner);
          ev.stopPropagation();
          this.closeMenu();
          this.closeEdgePopup();
          const edgeType = this.S.edges[id];
          console.log(`[addHit] edgeType pour ${id} =`, edgeType);
          if (edgeType && edgeType !== 'straight' && rect) {
            console.log(`[addHit] → Appel showEdgePopup pour ${id}`);
            this.showEdgePopup(rect, corner, id, ev);
            return;
          }
          console.log(`[addHit] → Affichage menu standard pour ${id}`);
          if (this._eff?.edgeTypes) CFG_applyEdgeTypes(this, this._eff.edgeTypes);

          /* ═══ PLACEMENT DU MENU — RÉV.20 : ancré au VIEWPORT ═══
             Le menu est en position:fixed (CSS §14). Il ne doit donc PAS
             être calé sur #stage : sur mobile le stage est plus court que le
             menu, et tout placement relatif au stage sortait de l'écran.
             MB (28) est plus grand que MM (12) : la marge basse doit tenir
             compte des barres d'outils mobiles, sinon le menu se retrouve
             collé au bas de l'écran, mi-caché. */
          this.menu.style.transform = 'none';
          this.menu.classList.remove('hidden');

          const MM = 12, MB = 28;
          const _mx = ev.clientX, _my = ev.clientY;

          const placeMenu = () => {
            if (this.menu.classList.contains('hidden')) return;
            const vw = document.documentElement.clientWidth;
            const vh = document.documentElement.clientHeight;
            const mw = this.menu.offsetWidth  || 220;
            const mh = this.menu.offsetHeight || 200;

            let mlx = _mx + 10;
            let mly = _my + 10;
            if (mlx + mw > vw - MM) mlx = _mx - mw - 10;
            if (mly + mh > vh - MB) mly = _my - mh - 10;

            mlx = Math.max(MM, Math.min(mlx, vw - mw - MM));
            mly = Math.max(MM, Math.min(mly, vh - mh - MB));

            const host = this.menu.offsetParent;
            const hr   = host ? host.getBoundingClientRect() : null;
            this.menu.style.left = (mlx - (hr ? hr.left : 0)) + 'px';
            this.menu.style.top  = (mly - (hr ? hr.top  : 0)) + 'px';
          };

          /* Trois passes : la premiere mesure un menu dont la police n'est
             pas encore chargee, sa hauteur change ensuite de quelques pixels
             et le bornage devient faux. Cout nul, aucun clignotement. */
          placeMenu();
          requestAnimationFrame(placeMenu);
          setTimeout(placeMenu, 160);

          /* MEMORISATION DE LA CIBLE — rect et corner sont indispensables au
             gestionnaire du menu pour rouvrir la popup de saisie sur le bon
             coin. closeMenu() remet menuTarget a null, on lit donc ces trois
             valeurs AVANT de fermer, cote gestionnaire. */
          this.menuTarget = id;
          this.menuRect   = rect;
          this.menuCorner = corner;
          const titles = {
            topLeft:'Coin haut-gauche',
            topRight:'Coin haut-droit',
            bottomLeft:'Coin bas-gauche',
            bottomRight:'Coin bas-droit',
            /* lot « messages 2 », N17 à N20 : les noms du dessin (cp-a11y, window.CP_titreCoin, d'abord) ; cette table en repli */
            endHTL:'Coin : plan principal, en haut à gauche',
            endHTR:'Coin : plan principal, en haut à droite',
            endHBL:'Coin : plan principal, en bas à gauche',
            endHBR:'Coin : plan principal, en bas à droite',
            endVTL:'Coin : retour, en haut à gauche',
            endVTR:'Coin : retour, en haut à droite',
            endVBL:'Coin : extrémité du retour, en bas à gauche',
            endVBR:'Coin : extrémité du retour, en bas à droite',
            footLTL:'Coin : jambe gauche, en haut à gauche',
            footLBL:'Coin : jambe gauche, en bas à gauche',
            footLBR:'Coin : jambe gauche, en bas à droite',
            footRTL:'Coin : jambe droite, en haut à gauche',
            footRTR:'Coin : jambe droite, en haut à droite',
            footRBL:'Coin : jambe droite, en bas à gauche',
            footRBR:'Coin : jambe droite, en bas à droite',
            gLeftTL:'Coin : montant gauche, en haut à gauche',
            gLeftBL:'Coin : montant gauche, en bas à gauche',
            gLeftBR:'Coin : montant gauche, en bas à droite',
            gTopTL:'Coin : plan du haut, en haut à gauche',
            gTopTR:'Coin : plan du haut, en haut à droite',
            gTopBR:'Coin : plan du haut, en bas à droite',
            gRightTL:'Coin : montant droit, en haut à gauche',
            gRightTR:'Coin : montant droit, en haut à droite',
            gRightBL:'Coin : montant droit, en bas à gauche',
            gRightBR:'Coin : montant droit, en bas à droite',
            gReturnTL:'Coin : retour, en haut à gauche',
            gReturnTR:'Coin : retour, en haut à droite',
            gReturnBL:'Coin : retour, en bas à gauche',
            gReturnBR:'Coin : retour, en bas à droite'
          };
          document.getElementById('menu-title').textContent=(typeof window.CP_titreCoin === 'function' && window.CP_titreCoin(this, id))||titles[id]||'Type de bord';
          this.updateMenuSelection();
        });
        this.svg.appendChild(g);
        console.log(`[addHit] Zone ${id} ajoutée au SVG`);
      },
      closeMenu(){
        this.menu.classList.add('hidden');
        this.menuTarget=null;
        /* rect / corner sont volontairement CONSERVES : le gestionnaire du
           menu les lit apres closeMenu() pour rouvrir la popup de saisie. */
      },

      
      capR(type,limit){
        return type==='semi' ? Math.min(limit/2,1e9) :
               type==='round1' ? Math.min(this.S.roundRadius||30,limit/2) :
               0;
      },
      applySemiRoundIfPair(rad,h,leftTypes,rightTypes){
        const [tLT,tLB]=leftTypes,
              [tRT,tRB]=rightTypes;
        if(tLT==='semi'&&tLB==='semi') rad.tl=rad.bl=Math.min(h/2,1e9);
        if(tRT==='semi'&&tRB==='semi') rad.tr=rad.br=Math.min(h/2,1e9);
      },
      clampBevel(dx,maxX,dy,maxY){
        return{
          dx:Math.max(0,Math.min(dx,maxX-1)),
          dy:Math.max(0,Math.min(dy,maxY-1))
        };
      },
      getCornerBandOffset(edgeKey, axis, maxW, maxH){
        const t = this.S.edges[edgeKey];
        if (!t || t === 'straight') return 0;
        // 🔶 ENCOCHE
        if (t === 'notch') {
          // on récupère la conf d'encoche du coin
          const conf = this.S.notch && this.S.notch[edgeKey];
          if (!conf) return 0;
          // compat : certains codes utilisent dx/dy, d'autres nx/ny
          const rawDx = (conf.dx != null ? conf.dx : conf.nx) || 0;
          const rawDy = (conf.dy != null ? conf.dy : conf.ny) || 0;
          const dx = Math.max(0, Math.min(rawDx, maxW - 1));
          const dy = Math.max(0, Math.min(rawDy, maxH - 1));
          // axe X → on veut la largeur de l'encoche
          // axe Y → on veut la hauteur de l'encoche
          return axis === 'x' ? dx : dy;
        }
        // 🔶 BISEAU
        if (t === 'bevel') {
          const conf = this.S.bevel[edgeKey];
          if (!conf) return 0;
          const cl = this.clampBevel(conf.dx, maxW, conf.dy, maxH);
          return axis === 'x' ? cl.dx : cl.dy;
        }
        // 🔶 ARRONDI & DEMI-ROND
        if (t === 'round1' || t === 'semi') {
          const r = this.capR(t, Math.min(maxW, maxH));
          return r;
        }
        return 0;
      },
      // Dessine le petit morceau de chant bleu qui suit la forme du coin
      drawCornerBanding(rect, corner, edgeKey){
        const t = this.S.edges[edgeKey];
        if(!t || t === 'straight') return;
        if (t === 'notch') return;
        let d = '';
        if(t === 'bevel'){
          const conf = this.S.bevel[edgeKey];
          if(!conf) return;
          const { dx, dy } = this.clampBevel(conf.dx, rect.w, conf.dy, rect.h);
          if(corner === 'tl'){
            d = `M ${rect.x},${rect.y+dy} L ${rect.x+dx},${rect.y}`;
          }else if(corner === 'tr'){
            d = `M ${rect.x+rect.w-dx},${rect.y} L ${rect.x+rect.w},${rect.y+dy}`;
          }else if(corner === 'br'){
            d = `M ${rect.x+rect.w},${rect.y+rect.h-dy} L ${rect.x+rect.w-dx},${rect.y+rect.h}`;
          }else if(corner === 'bl'){
            d = `M ${rect.x+dx},${rect.y+rect.h} L ${rect.x},${rect.y+rect.h-dy}`;
          }
        }else if(t === 'round1' || t === 'semi'){
          const r = this.capR(t, Math.min(rect.w, rect.h));
          if(!r) return;
          if(corner === 'tl'){
            d = `M ${rect.x},${rect.y+r} A ${r},${r} 0 0 1 ${rect.x+r},${rect.y}`;
          }else if(corner === 'tr'){
            d = `M ${rect.x+rect.w-r},${rect.y} A ${r},${r} 0 0 1 ${rect.x+rect.w},${rect.y+r}`;
          }else if(corner === 'br'){
            d = `M ${rect.x+rect.w},${rect.y+rect.h-r} A ${r},${r} 0 0 1 ${rect.x+rect.w-r},${rect.y+rect.h}`;
          }else if(corner === 'bl'){
            d = `M ${rect.x+r},${rect.y+rect.h} A ${r},${r} 0 0 1 ${rect.x},${rect.y+rect.h-r}`;
          }
        }
        if(!d) return;
        const path = this.SV('path', {
          d,
          fill:'none',
          stroke:'#1F51FF',
          'stroke-width':16,
          'stroke-linecap':'round',
          'stroke-linejoin':'round',
          opacity:0.85,
          'pointer-events':'none'
        });
        this.svg.appendChild(path);
      },
      pathWithFeatures(w, h, rad = {}, cut = {}, notch = {}) {
        const r = { tl: 0, tr: 0, br: 0, bl: 0, ...rad };
        const c = { tl: null, tr: null, br: null, bl: null, ...cut };
        const n = { tl: null, tr: null, br: null, bl: null, ...notch };
        // n[corner] = [dx, dy, offset] - offset est TOUJOURS horizontal
        let d = '';
        // ===== DÉPART - COIN TL =====
        if (n.tl) {
          const [dx, dy, off = 0] = n.tl;
          if (off > 0) {
            d = `M 0,0 H ${off} V ${dy} H ${off + dx} V 0 `;
          } else {
            d = `M ${dx},0 `;
          }
        } else if (c.tl) {
          d = `M ${c.tl[0]},0 `;
        } else if (r.tl) {
          d = `M ${r.tl},0 `;
        } else {
          d = `M 0,0 `;
        }
        // ===== BORD SUPÉRIEUR -> COIN TR =====
        if (n.tr) {
          const [dx, dy, off = 0] = n.tr;
          d += `H ${w - off - dx} `;
          d += `V ${dy} H ${w - off} V 0 `;
          if (off > 0) {
            d += `H ${w} `;
          }
        } else if (c.tr) {
          d += `H ${w - c.tr[0]} L ${w},${c.tr[1]} `;
        } else if (r.tr) {
          d += `H ${w - r.tr} A ${r.tr},${r.tr} 0 0 1 ${w},${r.tr} `;
        } else {
          d += `H ${w} `;
        }
        // ===== BORD DROIT -> COIN BR =====
        if (n.br) {
          const [dx, dy, off = 0] = n.br;
          if (off > 0) {
            // Descendre tout le bord droit jusqu'en bas
            d += `V ${h} `;
            // Aller jusqu'au début de l'encoche (depuis la droite)
            d += `H ${w - off} `;
            // Monter dans l'encoche
            d += `V ${h - dy} `;
            // Traverser l'encoche vers la gauche
            d += `H ${w - off - dx} `;
            // Descendre pour revenir au bord inférieur
            d += `V ${h} `;
          } else {
            // Encoche au coin (offset = 0)
            d += `V ${h - dy} `;
            d += `H ${w - dx} `;
            d += `V ${h} `;
          }
        } else if (c.br) {
          d += `V ${h - c.br[1]} L ${w - c.br[0]},${h} `;
        } else if (r.br) {
          d += `V ${h - r.br} A ${r.br},${r.br} 0 0 1 ${w - r.br},${h} `;
        } else {
          d += `V ${h} `;
        }
        // ===== BORD INFÉRIEUR -> COIN BL =====
        if (n.bl) {
          const [dx, dy, off = 0] = n.bl;
          d += `H ${off + dx} `;
          d += `V ${h - dy} H ${off} V ${h} `;
          if (off > 0) {
            d += `H 0 `;
          }
        } else if (c.bl) {
          d += `H ${c.bl[0]} L 0,${h - c.bl[1]} `;
        } else if (r.bl) {
          d += `H ${r.bl} A ${r.bl},${r.bl} 0 0 1 0,${h - r.bl} `;
        } else {
          d += `H 0 `;
        }
        // ===== BORD GAUCHE -> FERMETURE COIN TL =====
        if (n.tl) {
          const [dx, dy, off = 0] = n.tl;
          if (off > 0) {
            d += `V 0 Z`;
          } else {
            d += `V ${dy} H ${dx} V 0 Z`;
          }
        } else if (c.tl) {
          d += `V ${c.tl[1]} L ${c.tl[0]},0 Z`;
        } else if (r.tl) {
          d += `V ${r.tl} A ${r.tl},${r.tl} 0 0 1 ${r.tl},0 Z`;
        } else {
          d += `V 0 Z`;
        }
        return d;
      },
      drawJunction(x1,y1,x2,y2,depth=8,reverse=false){
        const dx=x2-x1,
              dy=y2-y1,
              len=Math.hypot(dx,dy);
        if(len===0) return;
        const nx=dx/len,
              ny=dy/len,
              sign=reverse?1:-1,
              px=sign*ny*depth,
              py=sign*-nx*depth,
              cx=(x1+x2)/2+px,
              cy=(y1+y2)/2+py;
        const g=this.SV('g',{class:'junction-group'});
        g.appendChild(this.SV('path',{
          d:`M ${x1},${y1} Q ${cx},${cy} ${x2},${y2} L ${x2},${y2} L ${x1},${y1} Z`,
          fill:'#1a1f2e',
          stroke:'none',
          opacity:'0.9'
        }));
        g.appendChild(this.SV('path',{
          d:`M ${x1},${y1} Q ${cx},${cy} ${x2},${y2}`,
          fill:'none',
          stroke:'#64748b',
          'stroke-width':'3',
          'stroke-linecap':'round'
        }));
        g.appendChild(this.SV('path',{
          d:`M ${x1},${y1} Q ${cx+px*0.3},${cy+py*0.3} ${x2},${y2}`,
          fill:'none',
          stroke:'#94a3b8',
          'stroke-width':'1.5',
          'stroke-linecap':'round',
          opacity:'0.4'
        }));
        g.appendChild(this.SV('path',{
          d:`M ${x1},${y1} Q ${cx+px*1.2},${cy+py*1.2} ${x2},${y2}`,
          fill:'none',
          stroke:'#0f172a',
          'stroke-width':'2',
          'stroke-linecap':'round',
          opacity:'0.6'
        }));
        this.svg.appendChild(g);
      },
      addJunctionLine(x1,y1,x2,y2,junctionId='default'){
        let jType;
        if (junctionId === 'leftU') {
          jType = this.S.junctionLeftU;
        } else if (junctionId === 'rightU') {
          jType = this.S.junctionRightU;
        } else if (junctionId === 'topG') {
          jType = this.S.junctionTopG;
        } else if (junctionId === 'midG') {
          jType = this.S.junctionMidG;
        } else if (junctionId === 'returnG') {
          jType = this.S.junctionReturnG;
        } else {
          jType = this.S.junctionType;
        }
        const group = this.SV('g',{class:'junction-group'});
        const clickZone = this.SV('line',{x1,y1,x2,y2,class:'junction-clickzone'});
        const line = this.SV('line',{x1,y1,x2,y2,class:`junction-line ${jType}`});
        const handleClick = (e) => {
          e.stopPropagation();
          if(junctionId==='leftU'){
            this.S.junctionLeftU = this.S.junctionLeftU==='flush'?'overlap':'flush';
          }else if(junctionId==='rightU'){
            this.S.junctionRightU = this.S.junctionRightU==='flush'?'overlap':'flush';
          }else if(junctionId==='topG'){
            this.S.junctionTopG = this.S.junctionTopG==='flush'?'overlap':'flush';
          }else if(junctionId==='midG'){
            this.S.junctionMidG = this.S.junctionMidG==='flush'?'overlap':'flush';
          }else if(junctionId==='returnG'){
            this.S.junctionReturnG = this.S.junctionReturnG==='flush'?'overlap':'flush';
          }else{
            this.S.junctionType = this.S.junctionType==='flush'?'overlap':'flush';
            const jRadio = document.getElementById(this.S.junctionType==='flush'?'j-flush':'j-overlap');
            if (jRadio) jRadio.checked = true;
          }

          if (typeof updateTdForme === 'function') updateTdForme();
if (typeof updateRecapShapeIcon === 'function') updateRecapShapeIcon();

          this.render();
        };
        clickZone.addEventListener('click', handleClick);
        line.addEventListener('click', handleClick);
        group.appendChild(clickZone);
        group.appendChild(line);
        this.svg.appendChild(group);
      },
calculateDepthSupplements() {
  const result = { total: 0, items: [], segments: [] };
  const CONFIG = window.CONFIGURATOR_CONFIG || {};
  const standardDepths = CONFIG.depthStandards || [];
  const customRanges = CONFIG.depthCustomRanges || [];
  const layout = this.S.layout || 'linear';

  const getDepthSupplementPerMeter = (depthMm) => {
    const depth = Number(depthMm || 0);
    if (depth <= 0) return 0;
    const standardMatch = standardDepths.find(opt => Number(opt.depth_mm) === depth);
    if (standardMatch) return Number(standardMatch.extraPrice || 0);
    const customMatch = customRanges.find(opt =>
      depth >= Number(opt.min_mm || 0) && depth <= Number(opt.max_mm || 99999)
    );
    if (customMatch) return Number(customMatch.extraPrice || 0);
    return 0;
  };

  // ===== LINÉAIRE =====
  if (layout === 'linear') {
    const L = Number(this.S.L || 0);
    const P = Number(this.S.P || 0);
    const supp = getDepthSupplementPerMeter(P);
    if (supp > 0) {
      const cents = Math.round(supp * (L / 1000) * 100);
      result.items.push({ label: `Prof. ${P} mm (+${supp}€/m)`, cents });
      result.total += cents;
    }
  }

  // ===== ANGLE =====
  else if (layout === 'angle') {
    const P1 = Number(this.S.P1 || 0);
    const P2 = Number(this.S.P2 || 0);
    const isFlush = (this.S.junctionType === 'flush');

    // Longueurs réelles selon jonction
    let L1real, L2real;
    if (isFlush) {
      L1real = Math.max(0, Number(this.S.L1 || 0) - P2);
      L2real = Math.max(0, Number(this.S.L2 || 0) + P1);
    } else {
      L1real = Number(this.S.L1 || 0);
      L2real = Number(this.S.L2 || 0);
    }

    const s1 = getDepthSupplementPerMeter(P1);
    const s2 = getDepthSupplementPerMeter(P2);

    if (s1 > 0 && L1real > 0) {
      const c = Math.round(s1 * (L1real / 1000) * 100);
      result.items.push({ label: `Prof. P1 ${P1} mm (+${s1}€/m × ${Math.round(L1real)}mm)`, cents: c });
      result.total += c;
    }
    if (s2 > 0 && L2real > 0) {
      const c = Math.round(s2 * (L2real / 1000) * 100);
      result.items.push({ label: `Prof. P2 ${P2} mm (+${s2}€/m × ${Math.round(L2real)}mm)`, cents: c });
      result.total += c;
    }
  }

  // ===== U-SHAPE =====
  else if (layout === 'u-shape') {
    const Lg = Number(this.S.Lg || 0);
    const Lc = Number(this.S.Lc || 0);
    const Ld = Number(this.S.Ld || 0);
    const Pl = Number(this.S.Pl || 0);
    const Pc = Number(this.S.Pc || 0);
    const Pr = Number(this.S.Pr || 0);

    const leftFlush = (this.S.junctionLeftU === 'flush');
    const rightFlush = (this.S.junctionRightU === 'flush');

    // Longueurs réelles selon jonctions
    let LgReal, LcReal, LdReal;

    if (leftFlush && rightFlush) {
      LgReal = Lg + Pc;
      LcReal = Lc;
      LdReal = Ld + Pc;
    } else if (leftFlush && !rightFlush) {
      LgReal = Lg + Pc;
      LcReal = Lc + Pl;
      LdReal = Ld;
    } else if (!leftFlush && rightFlush) {
      LgReal = Lg;
      LcReal = Lc + Pr;
      LdReal = Ld + Pc;
    } else {
      LgReal = Lg;
      LcReal = Lc + Pl + Pr;
      LdReal = Ld;
    }

    const sl = getDepthSupplementPerMeter(Pl);
    const sc = getDepthSupplementPerMeter(Pc);
    const sr = getDepthSupplementPerMeter(Pr);

    if (sl > 0 && LgReal > 0) {
      const c = Math.round(sl * (LgReal / 1000) * 100);
      result.items.push({ label: `Prof. Pl ${Pl} mm (+${sl}€/m × ${Math.round(LgReal)}mm)`, cents: c });
      result.total += c;
    }
    if (sc > 0 && LcReal > 0) {
      const c = Math.round(sc * (LcReal / 1000) * 100);
      result.items.push({ label: `Prof. Pc ${Pc} mm (+${sc}€/m × ${Math.round(LcReal)}mm)`, cents: c });
      result.total += c;
    }
    if (sr > 0 && LdReal > 0) {
      const c = Math.round(sr * (LdReal / 1000) * 100);
      result.items.push({ label: `Prof. Pr ${Pr} mm (+${sr}€/m × ${Math.round(LdReal)}mm)`, cents: c });
      result.total += c;
    }
  }

  // ===== G-SHAPE =====
  else if (layout === 'g-shape') {
    const Gleft = Number(this.S.Gleft || 0);
    const Gtop = Number(this.S.Gtop || 0);
    const Gright = Number(this.S.Gright || 0);
    const Greturn = Number(this.S.Greturn || 0);

    const Pgleft = Number(this.S.Pgleft || 0);
    const Pgtop = Number(this.S.Pgtop || 0);
    const Pgright = Number(this.S.Pgright || 0);
    const Pgreturn = Number(this.S.Pgreturn || 0);

    const isRight = (this.S.gDir === 'right');
    const topFlush = (this.S.junctionTopG === 'flush');
    const midFlush = (this.S.junctionMidG === 'flush');
    const returnFlush = (this.S.junctionReturnG === 'flush');

    // Longueurs réelles selon les 3 jonctions
    let GleftReal, GtopReal, GrightReal, GreturnReal;

    if (isRight) {
      // G DROIT
      if (topFlush) {
        GleftReal = Gleft + Pgtop;
      } else {
        GleftReal = Gleft;
      }

      if (topFlush && midFlush) {
        GtopReal = Gtop;
      } else if (topFlush && !midFlush) {
        GtopReal = Gtop - Pgright;
      } else if (!topFlush && midFlush) {
        GtopReal = Gtop + Pgleft;
      } else {
        GtopReal = Gtop + Pgleft - Pgright;
      }

      if (midFlush && returnFlush) {
        GrightReal = Gright + Pgreturn - Pgtop;
      } else if (midFlush && !returnFlush) {
        GrightReal = Gright - Pgreturn;
      } else if (!midFlush && returnFlush) {
        GrightReal = Gright + Pgtop;
      } else {
        GrightReal = Gright;
      }

      if (returnFlush) {
        GreturnReal = Greturn;
      } else {
        GreturnReal = Greturn + Pgright;
      }
    } else {
      // G GAUCHE (symétrique)
      if (topFlush) {
        GrightReal = Gright + Pgtop;
      } else {
        GrightReal = Gright;
      }

      if (topFlush && midFlush) {
        GtopReal = Gtop;
      } else if (topFlush && !midFlush) {
        GtopReal = Gtop - Pgleft;
      } else if (!topFlush && midFlush) {
        GtopReal = Gtop + Pgright;
      } else {
        GtopReal = Gtop + Pgright - Pgleft;
      }

      if (midFlush && returnFlush) {
        GleftReal = Gright + Pgreturn - Pgtop;
      } else if (midFlush && !returnFlush) {
        GleftReal = Gright - Pgreturn;
      } else if (!midFlush && returnFlush) {
        GleftReal = Gright + Pgtop;
      } else {
        GleftReal = Gright;
      }

      if (returnFlush) {
        GreturnReal = Greturn;
      } else {
        GreturnReal = Greturn + Pgright;
      }
    }

    const sL = getDepthSupplementPerMeter(isRight ? Pgleft : Pgright);
    const sT = getDepthSupplementPerMeter(Pgtop);
    const sR = getDepthSupplementPerMeter(isRight ? Pgright : Pgleft);
    const sRet = getDepthSupplementPerMeter(Pgreturn);

    // Montant gauche (GleftReal) ou droit (GrightReal) selon orientation
    if (sL > 0 && (isRight ? GleftReal : GrightReal) > 0) {
      const c = Math.round(sL * ((isRight ? GleftReal : GrightReal) / 1000) * 100);
      result.items.push({ label: `Prof. ${isRight ? 'Pgleft' : 'Pgright'} ${isRight ? Pgleft : Pgright} mm (+${sL}€/m × ${Math.round(isRight ? GleftReal : GrightReal)}mm)`, cents: c });
      result.total += c;
    }

    // Barre haute (GtopReal)
    if (sT > 0 && GtopReal > 0) {
      const c = Math.round(sT * (GtopReal / 1000) * 100);
      result.items.push({ label: `Prof. Pgtop ${Pgtop} mm (+${sT}€/m × ${Math.round(GtopReal)}mm)`, cents: c });
      result.total += c;
    }

    // Montant droit (GrightReal) ou gauche (GleftReal) selon orientation
    if (sR > 0 && (isRight ? GrightReal : GleftReal) > 0) {
      const c = Math.round(sR * ((isRight ? GrightReal : GleftReal) / 1000) * 100);
      result.items.push({ label: `Prof. ${isRight ? 'Pgright' : 'Pgleft'} ${isRight ? Pgright : Pgleft} mm (+${sR}€/m × ${Math.round(isRight ? GrightReal : GleftReal)}mm)`, cents: c });
      result.total += c;
    }

    // Retour (GreturnReal)
    if (sRet > 0 && GreturnReal > 0) {
      const c = Math.round(sRet * (GreturnReal / 1000) * 100);
      result.items.push({ label: `Prof. Pgreturn ${Pgreturn} mm (+${sRet}€/m × ${Math.round(GreturnReal)}mm)`, cents: c });
      result.total += c;
    }
  }

  return result;
}
,

      calculateLegsSupplements() {
  const euroToCents = (e) => Math.round(Number(e || 0) * 100);
  const result = { total: 0, items: [] };

  // ✅ NOUVELLE VÉRIFICATION : suppléments jambages désactivés pour cette collection ?
  if (this._eff?.legsSupplementEnabled === false) {
    return result;
  }

  const legs = this.S.legs || {};
  const hasLeft = !!legs.left;
  const hasRight = !!legs.right;
  const legsCount = (hasLeft ? 1 : 0) + (hasRight ? 1 : 0);

  if (legsCount === 0) return result;

  const legDepthMm = this.getLegsDepthMm();
  const legsPriceDefault = Number(this._eff?.legsPriceDefault || 0);
  const legsPriceRanges = this._eff?.legsPriceRanges || [];

  // Chercher l'intervalle correspondant
  let pricePerLegEuro = legsPriceDefault;
  for (const range of legsPriceRanges) {
    if (legDepthMm >= range.min && legDepthMm <= range.max && range.price > 0) {
      pricePerLegEuro = range.price;
      break;
    }
  }

  // Prix = prix unitaire × nombre de jambages
  const totalPriceCents = euroToCents(pricePerLegEuro * legsCount);

  if (totalPriceCents > 0) {
    const label = legsCount === 1 
      ? `Jambage (P: ${legDepthMm} mm)` 
      : `Jambages ×${legsCount} (P: ${legDepthMm} mm)`;
    
    result.items.push({ label, cents: totalPriceCents });
    result.total = totalPriceCents;
  }

  return result;
},

getLegsDepthMm() {
  // Retourne la profondeur utilisée pour les jambages selon la forme
  const layout = this.S.layout || 'linear';
  const legs = this.S.legs || {};
  const hasLeft = !!legs.left;
  const hasRight = !!legs.right;

  if (layout === 'linear') {
    return Number(this.S.P || 600);
  }

  if (layout === 'angle') {
    const isRight = this.S.angleDir === 'right';
    // Jambage gauche = P1, jambage droit = P2 (ou inversé)
    if (hasLeft && hasRight) {
      return Math.max(Number(this.S.P1 || 600), Number(this.S.P2 || 600));
    }
    if (hasLeft) {
      return isRight ? Number(this.S.P1 || 600) : Number(this.S.P2 || 600);
    }
    if (hasRight) {
      return isRight ? Number(this.S.P2 || 600) : Number(this.S.P1 || 600);
    }
    return Number(this.S.P1 || 600);
  }

  if (layout === 'u-shape') {
    // Jambage gauche = Pl, jambage droit = Pr
    if (hasLeft && hasRight) {
      return Math.max(Number(this.S.Pl || 600), Number(this.S.Pr || 600));
    }
    if (hasLeft) return Number(this.S.Pl || 600);
    if (hasRight) return Number(this.S.Pr || 600);
    return Number(this.S.Pl || 600);
  }

  if (layout === 'g-shape') {
    // Jambage gauche = Pgleft, jambage droit = Pgreturn
    if (hasLeft && hasRight) {
      return Math.max(Number(this.S.Pgleft || 600), Number(this.S.Pgreturn || 400));
    }
    if (hasLeft) return Number(this.S.Pgleft || 600);
    if (hasRight) return Number(this.S.Pgreturn || 400);
    return Number(this.S.Pgleft || 600);
  }

  return 600;
},


// ========================================
/* ═══ Legs methods externalisées dans snippet-cfg-legs.liquid ═══ */
/* ═══ Sink methods externalisées dans snippet-cfg-sink.liquid ═══ */
      render(){
  this.clear();

  // ✅ Revalider le segment évier si le layout a changé
  if (this.S.sink && this.S.sink.sinkId) {
    const validSegs = this.getSegmentsForLayout().map(s => s.id);
    if (!validSegs.includes(this.S.sink.segment)) {
      this.S.sink.segment = validSegs[0] || 'main';
      this._centerSink(this.S.sink);
    } else {
      // Même segment valide → vérifier que les offsets tiennent dans les nouvelles dimensions
      const sinkCfg = this.getSinkConfig(this.S.sink.sinkId);
      if (sinkCfg) {
        const dd = this.getSegmentDims(this.S.sink.segment);
        const ef = this._sinkEffDims(sinkCfg, this.S.sink.segment);
        const m = 30;
        if ((this.S.sink.offsetLeftMm||0) + ef.w > dd.L - m || (this.S.sink.offsetBackMm||0) + ef.d > dd.P - m) {
          this._centerSink(this.S.sink);
        }
      }
    }
  }

  if (!this.hasSelectableEdgeTypes()) {
    this.closeMenu();
    this.closeEdgePopup();
  }

  const meta=this.variantsMeta[this.S.variant] || { fallbackColor:'#e5e7eb', name:this.S.variant||'—' };
  this.ensureVariantPatterns(this.S.variant||'default', meta.fallbackColor);

  if(this.S.layout==='linear') this.renderLinear();
  else if(this.S.layout==='angle') this.renderAngle();
  else if(this.S.layout==='u-shape') this.renderU();
  else if(this.S.layout==='g-shape') this.renderG();

  this.loadWorkTexture();
        const t=FORME_LABELS[this.S.layout] || this.S.layout;
        const dims=this.S.layout==='linear' ?`L:${this.S.L} × P:${this.S.P}` :
                   this.S.layout==='angle' ?`L1:${this.S.L1} · P1:${this.S.P1} · L2:${this.S.L2} · P2:${this.S.P2} · Angle:${this.S.innerAngle}°` :
                   `Lc:${this.S.Lc} · Pc:${this.S.Pc} · Lg:${this.S.Lg} · Ld:${this.S.Ld} · Pl:${this.S.Pl} · Pr:${this.S.Pr}`;
        const rt=(id)=>document.getElementById(id);
        rt('rec-type') && (rt('rec-type').textContent=t);
        rt('rec-dims') && (rt('rec-dims').textContent=dims+' mm');
        rt('rec-variant')&& (rt('rec-variant').textContent=meta.name||'—');
        this.updateEdgesRecap();
        if (typeof updateRecapShapeIcon === 'function') updateRecapShapeIcon();
       this.updateDims();
      this.updateTdOptionsList();
this.updateTdEpaisseur();
this.updateTdLongueurTotal();
this.updateRecapLengthHeader(); 
this.updateTdPrixTotal();
this.updateTdPrixBase();
this.updateAddToCartButtonState();
this.updateDisplayedMultiTotal();
/* ✅ V2 : Sync barre de config */
if (typeof ConfigBar !== 'undefined') ConfigBar.update(this);
/* ✅ V2 : Évier sur le plan */
this.renderSinkOnSVG();
this.updateSinkButtonState();
this.updateRecapSink();

      }
    };
    /* ═══ Merge des méthodes externalisées ═══ */
    /* Les méthodes de rendu (linéaire, angle, U, G) et l'option jambage
       sont produites par des snippets Liquid : elles ne peuvent pas vivre
       dans ce fichier .js, qui n'est pas interprété par Liquid. La section
       les dépose dans window._CFG_RENDERERS juste avant de charger ce
       fichier, on les greffe ici sur App comme legs et sink. */
    Object.assign(App, window._CFG_RENDERERS || {},
                       window._CFG_LEGS || {}, window._CFG_SINK || {});

    window.AppConfigurator = App;

    // ========================================
// COLLAPSE RECAP TABLE
// ========================================
(function() {
  const details = document.getElementById('recap-details');
  const collapsedInfo = document.getElementById('recap-collapsed-info');
  const qtyInput = document.getElementById('qty-input');
  const totalPrice = document.getElementById('total-multi-price');
  
  if (!details || !collapsedInfo) return;
  
  function updateCollapsedInfo() {
    if (details.open) {
      collapsedInfo.innerHTML = '';
    } else {
      const qty = qtyInput ? qtyInput.value : '1';
      const price = totalPrice ? totalPrice.textContent : '—';
      collapsedInfo.innerHTML = `
        <span class="collapsed-qty">Qté: ${qty}</span>
        <span class="collapsed-price">${price}</span>
      `;
    }
  }
  
  details.addEventListener('toggle', updateCollapsedInfo);
  
  if (totalPrice) {
    const observer = new MutationObserver(updateCollapsedInfo);
    observer.observe(totalPrice, { childList: true, characterData: true, subtree: true });
  }
  
  if (qtyInput) {
    qtyInput.addEventListener('change', updateCollapsedInfo);
  }
})();

// ========================================
// FULLSCREEN BUTTON (DESKTOP + MOBILE) - SMOOTH (avec multi-renders)
// Nécessite (optionnel mais recommandé) ces classes CSS :
// .stage.fs-preparing, .stage.fs-exiting, .stage.fs-ready
// ========================================
(function () {
  const btnFullscreen = document.getElementById("btn-fullscreen");
  const btnExitFullscreen = document.getElementById("btn-exit-fullscreen");
  const stage = document.querySelector(".stage");

  if (!btnFullscreen || !stage) return;

  const fullscreenSupported = !!(
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.msFullscreenEnabled
  );

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const useFallback = !fullscreenSupported || isIOS;

  let isMobileFullscreen = false;
  let isAnimating = false;

  function forceRender() {
    if (window.AppConfigurator) window.AppConfigurator.render();
  }

  function afterTwoFrames(cb) {
    requestAnimationFrame(() => requestAnimationFrame(cb));
  }

  // ✅ Multi renders "doux" : rAF + backoff + idle
  function multiRenderStabilize() {
    afterTwoFrames(() => {
      forceRender();

      const delays = [80, 180, 320, 520];
      delays.forEach((d) => setTimeout(forceRender, d));

      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => forceRender(), { timeout: 700 });
      }
    });
  }

  function setBtnText(isFs) {
    const span = btnFullscreen.querySelector("span");
    if (span) span.textContent = isFs ? "Quitter" : "Plein écran";
  }

  function applySmoothState(state) {
    // state: "preparing" | "exiting" | "ready"
    stage.classList.remove("fs-preparing", "fs-exiting", "fs-ready");
    if (state === "preparing") stage.classList.add("fs-preparing");
    if (state === "exiting") stage.classList.add("fs-exiting");
    if (state === "ready") stage.classList.add("fs-ready");
  }

  function requestNativeFullscreen() {
    const req =
      stage.requestFullscreen ||
      stage.webkitRequestFullscreen ||
      stage.msRequestFullscreen;

    if (req) req.call(stage);
  }

  function exitNativeFullscreen() {
    const exit =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.msExitFullscreen;

    if (exit) exit.call(document);
  }

  function enterFullscreen() {
    if (isAnimating) return;
    isAnimating = true;

    // Fade OUT court avant bascule (masque le "saut")
    applySmoothState("preparing");

    requestAnimationFrame(() => {
      if (useFallback) {
        stage.classList.add("is-fullscreen-mobile");
        document.body.classList.add("fullscreen-mobile-active");
        isMobileFullscreen = true;
        setBtnText(true);

        window.scrollTo({ top: 0, behavior: "smooth" });

        // Une fois stabilisé, multi-render puis fade IN
        setTimeout(() => {
          multiRenderStabilize();
          applySmoothState("ready");
          isAnimating = false;
        }, 160);
      } else {
        // Natif desktop : la suite se fait dans fullscreenchange
        requestNativeFullscreen();
        setBtnText(true);
        stage.classList.add("is-fullscreen");
      }
    });
  }

  function exitFullscreen() {
    if (isAnimating) return;
    isAnimating = true;

    // Fade OUT court avant sortie
    applySmoothState("exiting");

    if (useFallback || isMobileFullscreen) {
      setTimeout(() => {
        stage.classList.remove("is-fullscreen-mobile");
        document.body.classList.remove("fullscreen-mobile-active");
        isMobileFullscreen = false;
        setBtnText(false);

        // Multi-render après retour layout normal, puis fade IN
        multiRenderStabilize();
        setTimeout(() => {
          applySmoothState("ready");
          isAnimating = false;
        }, 220);
      }, 180);
    } else {
      // Natif desktop : la suite se fait dans fullscreenchange
      exitNativeFullscreen();
    }
  }

  function isInFullscreen() {
    return !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement ||
      isMobileFullscreen
    );
  }

 btnFullscreen.addEventListener("click", function () {    // ← ligne 5318
    if (isInFullscreen()) exitFullscreen();                 // ← ligne 5319
    else enterFullscreen();                                 // ← ligne 5320
  });                                                       // ← ligne 5321

  // ✅ Bouton quitter (dans le stage, visible en fullscreen)   ← ICI
  if (btnExitFullscreen) {
    btnExitFullscreen.addEventListener("click", function () {
      if (isInFullscreen()) exitFullscreen();
    });
  }


  

  // ✅ Fullscreen natif (desktop)
  function onFsChange(isNowFullscreen) {
    if (isNowFullscreen) {
      // ENTRÉE : attendre stabilité, multi-render, fade IN
      setTimeout(() => {
        multiRenderStabilize();
        applySmoothState("ready");
        isAnimating = false;
      }, 120);
    } else {
      // SORTIE : UI + multi-render + fade IN
      setBtnText(false);
      stage.classList.remove("is-fullscreen");

      setTimeout(() => {
        multiRenderStabilize();
        applySmoothState("ready");
        isAnimating = false;
      }, 140);
    }
  }

  document.addEventListener("fullscreenchange", function () {
    onFsChange(!!document.fullscreenElement);
  });

  document.addEventListener("webkitfullscreenchange", function () {
    onFsChange(!!document.webkitFullscreenElement);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isMobileFullscreen) exitFullscreen();
  });

  window.addEventListener("popstate", function () {
    if (isMobileFullscreen) exitFullscreen();
  });

  // État initial
  applySmoothState("ready");
})();




/* ═══════ SYNCHRONISATION DU RÉCAPITULATIF APRÈS LE DÉMARRAGE ═══════
   updateTdForme() et updateTdFinition() sont appelées par la section sur
   DOMContentLoaded. Or DOMContentLoaded précède TOUJOURS window.load, et
   c'est sur window.load que le moteur démarre : au moment où la section
   remplit la ligne « Finition », App.S.variant vaut encore sa valeur
   initiale — une chaîne vide. getWorkImageUrl() renvoie donc null et la
   cellule reçoit la pastille grise de repli, jamais le décor choisi.

   La ligne se corrigeait au premier clic parce que la section réécoute les
   clics sur .variant-opt, mais rien ne la rafraîchissait entre les deux.

   On rappelle donc les deux fonctions une fois le moteur prêt. Deux passes :
   la première dès que l'état est monté, la seconde 120 ms plus tard pour le
   cas où l'image du décor n'est pas encore résolue. Aucune de ces fonctions
   n'est appelée dans render() : elle vide et reconstruit la cellule, ce qui
   ferait clignoter la vignette à chaque frappe dans un champ de dimension. */
function cfgSyncRecapEntete(){
  if (typeof updateTdForme === 'function') updateTdForme();
  if (typeof updateTdFinition === 'function') updateTdFinition();
}

function bootConfigurator(){
  if(window.__PRODUCT__) App.setShopifyProduct(window.__PRODUCT__);
  App.init();
  App.initQtyUI();
  requestAnimationFrame(() => {
    App.render();
    cfgSyncRecapEntete();
  });
  setTimeout(cfgSyncRecapEntete, 120);
}

window.addEventListener('load', bootConfigurator);